export default {
    'all': 'ทั้งหมด',
    'archive': 'แหล่งจัดเก็บข้อมูล',
    'actions': 'ดำเนินการ',
    'download': 'ดาวน์โหลด',
    'pleaseSelect': 'โปรดเลือก',
    'country': 'ประเทศ',
    'province': 'จังหวัด',
    'district': 'เขต/อำเภอ',
    'area': 'แขวง/ตำบล',
    'document': 'เอกสาร',
    'records': 'รายการ',
    'found': 'พบ',
    'feature': 'แนะนำ',
    'percent': 'เปอร์เซนต์',
    'offerDetail': 'รายละเอียดข้อเสนอ',
    'print':'พิมพ์',
    'printing':'กำลังพิมพ์...',
    'loan':'Loan',
    'remove': 'ลบ',
    'advanceFilter': 'ค้นหาขั้นสูง',
    'allViewStations':'แสดงสถานีทั้งหมด',
    'from': 'ตั้งแต่',
    'to': 'ถึง',
    'id':'รหัส',
    'back': 'ย้อนกลับ',
    'reset': 'ล้างค่า',
    'name': 'ชื่อ',
    'tax': 'ภาษี',
    'noOfBathrooms': 'จำนวนห้องน้ำ',
    'noOfTotalrooms': 'จำนวนห้องทั้งหมด',
    'price': 'ราคา',
    'insert': 'แทรก',
    'address': 'ที่อยู่',
    'batch': 'แก้ไขรายการที่เลือก',
    'date':'วันที่',
    'findLocation':'ค้นหาตำแหน่ง',
    'saleOrRent' : 'ขาย / เช่า',
    'sureToDelete': 'ยืนยันการลบ?',
    'sureToDeleteProperty': 'Sure to delete?',
    'yes': 'ใช่',
    'no': 'ไม่',
    'max': 'สูงสุด',
    'thisFieldIsRequired': 'กรุณาใส่ข้อมูลให้ครบถ้วน',
    'mortgageCancelationDate':'Mortgage Cancellation Date',
    'mortgageCancelationDateText':'Mortgage Cancellation Date - Text',
    'commission.title.property': 'สินทรัพย์',
    'commission.title.price': 'ราคา',
    'commission.title.type': 'ประเภท',
    'commission.title.note': 'คำอธิบาย',
    'commission.title.percentage': 'Percentage',
    'commission.title.fixed': 'Fixed',
    'commission.title.total': 'รวม',
    'commission.title.dueDate': 'วันที่ทำสัญญา',
    'commission.title.export': 'ออกรายงาน',
    'commission.title.contractDate': 'วันที่ทำสัญญา',
    'commission.header.commissionReport': 'รายงานค่าคอมมิชชั่น',
    'commission.header.dateFrom': 'ตั้งแต่วันที่',
    'commission.header.dateTo': 'ถึงวันที่',
    'commission.table.export.excel': 'Excel',
    'commission.table.export.pdf': 'Pdf',
    'project.modalConfirm.deleteProjectTitle': 'ลบโครงการ',
    'project.modalConfirm.deleteProjectMessage': 'ยืนยันการลบโครงการนี้',
    'project.modalConfirm.deleteProjectUnitTypeTitle': 'ลบยูนิต',
    'project.modalConfirm.deletProjectUnitTypeMessage': 'ยืนยันการลบยูนิตนี้',
    'projectList.title.project': 'โครงการ',
    'projectList.title.projectName': 'ชื่อโครงการ',
    'projectList.title.location': 'สถานที่ตั้งโครงการ',
    'projectList.title.projectType': 'ชนิดของโครงการ',
    'projectList.title.unitsV': 'จำนวน',
    'projectList.title.lastUpdate': 'อัพเดทล่าสุด',
    'projectList.title.search': 'ค้นหาโครงการ',
    'projectList.button.addProject': 'เพิ่มโครงการใหม่',
    'projectList.button.updateProject': 'แก้ไขโครงการ',
    'projectList.validate.greaterThanFrom' : 'ต้องมากกว่าจาก',
    'projectDetail.portal': 'เว็บไซต์',
    'projectDetail.onWeb': 'แสดงบนเว็บไซต์',
    'projectDetail.notOnWeb': 'ไม่แสดงบนเว็บไซต์',
    'projectDetail.viewOnWeb': 'ดูบนเว็บไซต์',
    'projectDetail.button.selectAll': 'เลือกทั้งหมด',
    'projectDetail.button.selectNone': 'ไม่เลือกทั้งหมด',
    'projectDetail.button.invertSelect': 'เลือกกลับกัน',
    'projectDetail.button.batch': 'แก้ไขยูนิตที่เลือก',
    'projectDetail.textbox.projectName': 'ชื่อโครงการ',
    'projectDetail.dropdown.projectId': 'รหัสโครงการ',
    'projectDetail.dropdown.projectType': 'ชนิดโครงการ',
    'projectDetail.autocomeplete.developer': 'ผู้พัฒนาโครงการ',
    'projectDetail.textbox.totalUnit': 'จำนวนยูนิตทั้งหมด',
    'projectDetail.dropdown.location': 'ตำแหน่ง',
    'projectDetail.dropdown.area': 'พื้นที่',
    'projectDetail.textarea.address': 'ที่อยู่',
    'projectDetail.textbox.yearBuilt': 'ปีที่สร้าง',
    'projectDetail.textbox.yearComplete': 'ปีที่สร้างเสร็จ',
    'projectDetail.dropdown.status': 'สถานะ',
    'projectDetail.textbox.landSize': 'ขนาดพื้นที่',
    'projectDetail.textbox.rai': 'ไร่',
    'projectDetail.textbox.ngan': 'งาน',
    'projectDetail.textbox.wa': 'วา',
    'projectDetail.textbox.sqm': 'ตร.ม',
    'projectDetail.textbox.sqw': 'ตร.ว',
    'projectDetail.gallery': 'คลังภาพ',
    'projectDetail.floorPlan': 'แปลนอาคาร',
    'projectDetail.button.upload': 'อัพโหลด',
    'projectDetail.button.delete': 'ลบ',
    'projectDetail.textarea.remark': 'หมายเหตุ',
    'projectDetail.advertisementVdo': 'วิดีโอประชาสัมพันธ์',
    'projectDetail.textbox.unitType': 'ประเภทยูนิต',
    'unitcode': 'ชนิดยูนิต',
    'projectDetail.textbox.unitName': 'ชื่อยูนิต',
    'projectDetail.textbox.code': 'โค้ด',
    'projectDetail.textbox.size': 'ขนาด',
    'projectDetail.button.addUnitType': 'เพิ่มประเภทยูนิตโครงการ',
    'projectDetail.tab.unitDetail': 'รายละเอียดยูนิต',
    'projectDetail.tab.matrixView': 'แมทริกซ์',
    'projectDetail.tab.sales': 'การขาย',
    'projectDetail.tab.construction': 'ก่อสร้าง',
    'projectDetail.button.updateProjectUnits': 'แก้ไขรายละเอียดยูนิต',
    'projectDetail.button.showEnquiry': 'แสดงลูกค้าที่สนใจ',
    'projectDetail.button.showUnits': 'แสดงยูนิต',
    'projectDetail.button.projectReports': 'รายงานโครงการ',
    'projectDetail.button.unitList': 'รายการยูนิต',
    'projectDetail.button.addEnquiry': 'เพิ่มลูกค้าที่สนใจ',
    'projectDetail.button.addUnits': 'เพิ่มยูนิตใหม่',
    'projectDetail.button.deleteProject': 'ลบโครงการ',
    'projectDetail.matrix.quickSearch': 'ค้นหาทันที',
    'projectDetail.matrix.all': 'ทั้งหมด',
    'projectDetail.matrix.unitNumber': 'จำนวนยูนิต',
    'projectDetail.matrix.unitNumber2': 'จำนวนยูนิต',
    'projectDetail.matrix.unitType': 'ประเภทยูนิต',
    'projectDetail.matrix.selectUnitType': 'เลือกประเภทยูนิต',
    'projectDetail.matrix.price': 'ราคา',
    'projectDetail.matrix.lowestPrice': 'ราคาขั้นต่ำ',
    'projectDetail.matrix.saleState': 'สถานะการขาย',
    'projectDetail.matrix.selectSaleState': 'เลือกสถานะการขาย',
    'projectDetail.matrix.saleAgent': 'พนักงานขาย',
    'projectDetail.matrix.selectSaleAgent': 'เลือกพนักงานขาย',
    'projectDetail.matrix.saleRepresentative': 'ตัวแทนการขาย',
    'projectDetail.matrix.defect': 'ข้อเสียหาย',
    'projectDetail.matrix.selectDefect': 'เลือกข้อเสียหาย',
    'projectDetail.matrix.percentComplete': '% ความคืบหน้า',
    'projectDetail.matrix.markUpPrice': 'ปรับราคาขึ้น (%)',
    'projectDetail.matrix.markDownPrice': 'ปรับราคาลง (%)',
    'projectDetail.matrix.markUpMinPrice': 'ปรับราคาขั้นต่ำขึ้น (%)',
    'projectDetail.matrix.markDownMinPrice': 'ปรับราคาขั้นต่ำลง (%)',
    'projectDetail.matrix.batch': 'แก้ไขยูนิตที่เลือก',
    'projectDetail.matrix.useAsterisk': 'สามารถใช้เครื่องหมายดอกจันแทนอักษรใดๆ',
    'projectDetail.matrix.markUnit': 'หน่วย',
    'projectDetail.matrix.markPrice': 'ราคา',
    'projectDetail.matrix.markPercent': 'ร้อยละ(%)',
    'projectDetail.matrix.changeSaleState': 'สถานะการขาย',
    'projectDetail.matrix.changeSaleRepresentative': 'พนักงานขาย',
    'projectDetail.matrix.assignToAgent': 'ตัวแทนการขาย',
    'projectDetail.matrix.selectState': 'เลือกสถานะ',
    'projectDetail.matrix.selectSalesRepresentative': 'เลือกพนักงานขาย',
    'projectDetail.matrix.selectAgent': 'เลือกตัวแทนการขาย',
    'projectDetail.matrix.deleteUnits': 'ลบยูนิต',
    'projectDetail.matrix.deleteSelectedUnits': 'ลบยูนิตที่เลือก',
    'projectDetail.matrix.apply': 'ตกลง',
    'projectDetail.matrix.addDefect': 'เพิ่มข้อเสียหาย',
    'projectDetail.matrix.deleteDefect': 'ลบข้อเสียหาย',
    'projectDetail.report.unitWithoutUnitTypeWillNotShowinReport': 'Unit without unit type will not show in report',
    'projectDetail.gallery.tooltip': 'ตั้งชื่อภาพเป็น banner เพื่อกำหนดรูปเป็นรูปหลักของโครงการ, ตั้งชื่อภาพเป็น logo เพื่อกำหนดรูปเป็นเครื่องหมายของโครงการ',
    'projectFeature.propertyNearBy': 'พื้นที่ใกล้เคียง',
    'projectFeature.transportation': 'การเดินทาง',
    'projectFacility.facility': 'สิ่งอำนวยความสะดวก',
    'sidebar.email': 'อีเมล์',
    'sidebar.account': 'บัญชี',
    'sidebar.enquiry': 'ความต้องการ',
    'sidebar.enquiryDetail': 'รายละเอียดความต้องการ',
    'sidebar.lead': 'ผู้สนใจ',
    'sidebar.ecommerce': 'Ecommerce',
    'sidebar.shop': 'Shop',
    'sidebar.cart': 'Cart',
    'sidebar.checkout': 'Checkout',
    'sidebar.cards': 'Cards',
    'sidebar.maps': 'แผนที่',
    'sidebar.googleMap': 'Google Map',
    'sidebar.leafletMap': 'Leaflet Map',
    'sidebar.calendar': 'ปฏิทิน',
    'sidebar.notes': 'Notes',
    'sidebar.todos': 'Todos',
    'sidebar.contacts': 'รายชื่อผู้ติดต่อ',
    'sidebar.shuffle': 'Shuffle',
    'sidebar.charts': 'Charts',
    'sidebar.googleCharts': 'Google Carts',
    'sidebar.recharts': 'Recharts',
    'sidebar.reactVis': 'React Vis',
    'sidebar.reactChart2': 'React-Chart-2',
    'sidebar.reactTrend': 'React-Trend',
    'sidebar.eChart': 'Echart',
    'sidebar.forms': 'Forms',
    'sidebar.input': 'Input',
    'sidebar.editor': 'Editor',
    'sidebar.formsWithValidation': 'Forms With Validation',
    'sidebar.progress': 'Progress',
    'sidebar.button': 'Button',
    'sidebar.tab': 'Tab',
    'sidebar.checkbox': 'Checkbox',
    'sidebar.radiobox': 'Radiobox',
    'sidebar.transfer': 'Transfer',
    'sidebar.autocomplete': 'AutoComplete',
    'sidebar.boxOptions': 'Box Options',
    'sidebar.uiElements': 'UI Elements',
    'sidebar.badge': 'Badge',
    'sidebar.card2': 'Card',
    'sidebar.corusel': 'Carousal',
    'sidebar.collapse': 'Collapse',
    'sidebar.popover': 'Pop Over',
    'sidebar.tooltip': 'Tooltip',
    'sidebar.tag': 'Tag',
    'sidebar.timeline': 'Timeline',
    'sidebar.dropdown': 'Dropdown',
    'sidebar.pagination': 'Pagination',
    'sidebar.rating': 'Rating',
    'sidebar.tree': 'Tree',
    'sidebar.advancedElements': 'Advanced Elements',
    'sidebar.reactDates': 'React Dates',
    'sidebar.codeMirror': 'Code Mirror',
    'sidebar.uppy': 'Uppy Uploader',
    'sidebar.dropzone': 'Drop Zone',
    'sidebar.feedback': 'Feedback',
    'sidebar.alert': 'Alert',
    'sidebar.modal': 'Modal',
    'sidebar.message': 'Message',
    'sidebar.notification': 'Notification',
    'sidebar.popConfirm': 'Pop Confirm',
    'sidebar.spin': 'Spin',
    'sidebar.tables': 'Tables',
    'sidebar.antTables': 'Ant Tables',
    'sidebar.pages': 'Pages',
    'sidebar.500': '500',
    'sidebar.404': '404',
    'sidebar.signIn': 'Sign In',
    'sidebar.signUp': 'Sign Up',
    'sidebar.forgotPw': 'Forgot Passwords',
    'sidebar.resetPw': 'Reset Passwords',
    'sidebar.invoice': 'Invoice',
    'sidebar.menuLevels': 'Menu Levels',
    'sidebar.item1': 'Item 1',
    'sidebar.item2': 'Item 2',
    'sidebar.option1': 'Option 1',
    'sidebar.option2': 'Option 2',
    'sidebar.option3': 'Option 3',
    'sidebar.option4': 'Option 4',
    'sidebar.blankPage': 'Blank Page',
    'sidebar.githubSearch': 'Github Search',
    'sidebar.youtubeSearch': 'Youtube Search',
    'sidebar.projectList': 'รายการโครงการ',
    'sidebar.propertyList': 'รายการสินทรัพย์',
    'dashboard': 'แดชบอร์ด',
    'sidebar.settings': 'ตั้งค่า',
    'sidebar.settings.employeelist': 'รายชื่อพนักงาน',
    'sidebar.settings.officelist': 'ข้อมูลสำนักงาน',
    'sidebar.salesReport': 'รายงานการขาย',
    'sidebar.ExcelList': 'รายงาน Excel',
    'sidebar.PropertyReport': 'รายงานทรัพย์สิน',
    'sidebar.PropertyStatusReport': 'รายงานสถานะทรัพย์สิน',
    'sidebar.projectDetail': 'รายละเอียดโครงการ',
    'sidebar.switcherLanguage.thailand': 'ภาษาไทย',
    'sidebar.switcherLanguage.english': 'ภาษาอังกฤษ',
    'sidebar.sagaContacts': 'รายชื่อผู้ติดต่อ',
    'sidebar.sagaCalendar': 'ปฏิทิน',
    'sidebar.sagaEmail': 'อีเมล์',
    'sidebar.residential': 'ที่อยู่อาศัย',
    'sidebar.commercial': 'เชิงพาณิชย์',
    'sidebar.NFS': 'รายการขาย',
    'sidebar.NFR': 'รายการเช่า',
    'sidebar.sagaSettings': 'ตั้งค่า',
    'sidebar.contactDetail': 'รายละเอียดผู้ติดต่อ',
    'sidebar.enquiries': 'ความต้องการ',
    'sidebar.interests': 'ความสนใจ',
    'sidebar.properties': 'สินทรัพย์',
    'sidebar.addProject': 'เพิ่มโครงการใหม่',
    'sidebar.property': 'สินทรัพย์',
    'languageSwitcher.label': 'เปลี่ยนภาษา',
    'reports.label': 'รายงาน',
    'themeSwitcher': 'Theme Switcher',
    'themeSwitcher.Sidebar': 'Sidebar',
    'themeSwitcher.Topbar': 'Topbar',
    'themeSwitcher.Background': 'Background',
    'feedback.alert.basicTitle': 'Basic Title',
    'feedback.alert.successText': 'Success text',
    'feedback.alert.infoText': 'Info Text',
    'feedback.alert.warningText': 'Warning Text',
    'feedback.alert.errorText': 'Error Text',
    'feedback.alert.closableAlertType': 'Closable Alert Type',
    'feedback.alert.iconAlertType': 'Icon Alert Type',
    'feedback.alert.iconInfoAlertType': 'Icon Info Alert Type',
    'feedback.alert.successTips': 'success tips',
    'feedback.alert.successTipsDescription':
        'Detailed description and advices about successful copywriting.',
    'feedback.alert.informationTips': 'Informational Notes',
    'feedback.alert.informationDescription':
        'Additional description and informations about copywriting.',
    'feedback.alert.warningTips': 'แจ้งเตือน',
    'feedback.alert.warningDescription':
        'This is a warning notice about copywriting.',
    'feedback.alert.errorTips': 'Error',
    'feedback.alert.errorDescription':
        'This is an error message about copywriting.',
    'feedback.alert.modalTitle': 'Modal one with customize Footer',
    'feedback.alert.modalSubTitle': 'Basic modal dialog.',
    'feedback.alert.successTitle': 'Success',
    'feedback.alert.infoTitle': 'Info',
    'feedback.alert.errorTitle': 'Error',
    'feedback.alert.warningTitle': 'Warning',
    'feedback.alert.modalBlockTitle': 'Modal',
    'feedback.alert.confirmationModalDialogue': 'Confirmation modal dialog',
    'feedback.alert.simpleModalDialogue': 'Simple modal dialog',
    'feedback.alert.message': 'Message',
    'feedback.alert.normalMessageTitle': 'Normal Message',
    'feedback.alert.normalMessageSubtitle': 'Normal messages as feedbacks.',
    'feedback.alert.displayMessage': 'Display normal message',
    'feedback.alert.displayOtherTypeMessageTitle': 'Other Types of Message',
    'feedback.alert.displayOtherTypeMessageSubTitle': 'Messages of success   error and warning types.',
    'feedback.alert.customizeDurationTitle': 'Customize duration',
    'feedback.alert.customizeDurationSubTitle': 'ustomize message display duration from default 1.5s to 10s.',
    'feedback.alert.customizeDurationButton': 'Customized display duration',
    'feedback.alert.messageLoadingTitle': 'Message of loading',
    'feedback.alert.messageLoadingSubTitle': 'Display a global loading indicator   which is dismissed by itself asynchronously.',
    'feedback.alert.displayLoadIndicator': 'Display a loading indicator',
    'feedback.alert.notification': 'Notification',
    'feedback.alert.notificationBasicTitle': 'Basic',
    'feedback.alert.notificationBasicSubTitle':
        'The simplest usage that close the notification box after 4.5s.',
    'feedback.alert.notificationBasicDescription': 'Open the notification box',
    'feedback.alert.notificationDurationTitle':
        'Duration after which the notification box is closed',
    'feedback.alert.notificationDurationSubTitle':
        'Duration can be used to specify how long the notification stays open. After the duration time elapses   the notification closes automatically. If not specified   default value is 4.5 seconds. If you set the value to 0   the notification box will never close automatically.',
    'feedback.alert.notificationwithIconTitle': 'Notification with icon',
    'feedback.alert.notificationwithIconSubTitle':
        'A notification box with a icon at the left side.',
    'feedback.alert.notificationwithCustomIconTitle':
        'Notification with custom icon',
    'feedback.alert.notificationwithCustomIconSubTitle':
        'Normal messages as feedbacks.',
    'feedback.alert.notificationwithCustomButtonTitle':
        'Notification with custom button',
    'feedback.alert.notificationwithCustomButtonSubTitle':
        'Normal messages as feedbacks.',
    'feedback.alert.popConfirm': 'Pop Confirm',
    'feedback.alert.popConfirm.basicTitle': 'Basic Confirm',
    'feedback.alert.popConfirm.basicSubTitle': 'The basic example.',
    'feedback.alert.popConfirm.delete': 'Delete',
    'feedback.alert.popConfirm.notiWithIconTitle':
        'Notification with custom icon',
    'feedback.alert.popConfirm.notiWithIconSubTitle':
        'Normal messages as feedbacks.',
    'feedback.alert.popConfirm.TL': 'TL',
    'feedback.alert.popConfirm.top': 'Top',
    'feedback.alert.popConfirm.TR': 'TR',
    'feedback.alert.popConfirm.LT': 'LT',
    'feedback.alert.popConfirm.left': 'Left',
    'feedback.alert.popConfirm.LB': 'LB',
    'feedback.alert.popConfirm.RT': 'RT',
    'feedback.alert.popConfirm.right': 'Right',
    'feedback.alert.popConfirm.RB': 'RB',
    'feedback.alert.popConfirm.Bl': 'BL',
    'feedback.alert.popConfirm.bottom': 'Bottom',
    'feedback.alert.popConfirm.BR': 'BR',
    'feedback.alert.spin': 'Spin',
    'feedback.alert.spin.basicTitle': 'Size Spin',
    'feedback.alert.spin.background': 'Spin With Background',
    'feedback.alert.spin.backgroundDescription':
        'Spin With Background description',
    'feedback.alert.spin.loadingState': 'Loading State',
    'feedback.alert.spin.alertTitle': 'Alert message title',
    'feedback.alert.spin.alertDescription':
        'Further details about the context of this alert.',
    'feedback.alert.priceIsHigherThanPayment': 'ราคามากกว่ายอดชำระ',
    'feedback.alert.paymentAreHigherThanPrice': 'ยอดชำระมากกว่าราคา',
    'feedback.alert.warning.whenChangeTab': 'ข้อมูลยังไม่ได้ถูกบันทึก กรุณายืนยันหากไม่ต้องการบันทึก',
    'forms.input.header': 'Input',
    'forms.input.basicTitle': 'Basic usage',
    'forms.input.basicSubTitle': 'Basic usage example.',
    'forms.input.variationsTitle': 'Three sizes of Input',
    'forms.input.variationsSubtitle':
        'There are three sizes of an Input box  large (42px  、default (35px   and small (30px  . Note  Inside of forms   only the large size is used.',
    'forms.input.groupTitle': 'Input Group',
    'forms.input.groupSubTitle':
        'Input.Group example Note  You dont need Col to control the width in the compact mode.',
    'forms.input.autoSizingTitle': 'Autosizing the height to fit the content',
    'forms.input.autoSizingSubTitle':
        'autosize prop for a textarea type of Input makes the height to automatically adjust based on the content. An options object can be provided to autosize to specify the minimum and maximum number of lines the textarea will automatically adjust.',
    'forms.input.prePostTabTitle': 'Pre    Post tab',
    'forms.input.prePostTabSubTitle': 'Using pre &amp; post tabs example..',
    'forms.input.textAreaTitle': 'Textarea',
    'forms.input.textAreaSubTitle':
        'For multi-line user input cases   an input whose type prop has the value of textarea can be used.',
    'forms.input.searchTitle': 'Search',
    'forms.input.searchSubTitle':
        'Example of creating a search box by grouping a standard input with a search button',
    'forms.editor.header': 'Editor',
    'forms.formsWithValidation.header': 'Customized Validation Form',
    'forms.formsWithValidation.failLabel': 'Fail',
    'forms.formsWithValidation.failHelp':
        'Should be combination of numbers &amp; alphabets',
    'forms.formsWithValidation.warningLabel': 'Warning',
    'forms.formsWithValidation.ValidatingLabel': 'Validating',
    'forms.formsWithValidation.ValidatingHelp':
        'The information is being validated...',
    'forms.formsWithValidation.SuccessLabel': 'Success',
    'forms.formsWithValidation.WarninghasFeedbackLabel': 'Warning',
    'forms.formsWithValidation.FailhasFeedbackLabel': 'Fail',
    'forms.formsWithValidation.FailhasFeedbackHelp':
        'Should be combination of numbers &amp; alphabets',
    'forms.progressBar.header': 'Progress Bar',
    'forms.progressBar.standardTitle': 'Progress bar',
    'forms.progressBar.standardSubTitle': 'A standard progress bar.',
    'forms.progressBar.circularTitle': 'Circular Progress bar',
    'forms.progressBar.circularSubTitle': 'A circular progress bar.',
    'forms.progressBar.miniTitle': 'Mini size progress bar',
    'forms.progressBar.miniSubTitle': 'Appropriate for a narrow area.',
    'forms.progressBar.miniCircularTitle': 'A smaller circular progress bar.',
    'forms.progressBar.dynamicCircularTitle': 'Dynamic circular progress bar',
    'forms.progressBar.dynamicCircularSubTitle':
        'A dynamic progress bar is better.',
    'forms.progressBar.customTextTitle': 'Custom text format',
    'forms.progressBar.customTextSubTitle':
        'You can custom text format by setting format.',
    'forms.progressBar.dashboardTitle': 'Dashboard',
    'forms.progressBar.dashboardSubTitle': 'A dashboard style of progress.',
    'forms.button.header': 'Buttons',
    'forms.button.simpleButton': 'Button Type',
    'forms.button.iconButton': 'Button Icon',
    'forms.button.simpleButtonPrimaryText': 'Primary',
    'forms.button.simpleButtonDefaultText': 'Default',
    'forms.button.simpleButtonDashedText': 'Dashed',
    'forms.button.simpleButtonDangerText': 'Danger',
    'forms.button.iconPrimaryButton': 'search',
    'forms.button.iconSimpleButton': 'search',
    'forms.button.iconCirculerButton': 'search',
    'forms.button.iconDashedButton': 'search',
    'forms.button.SizedButton': 'Button Size',
    'forms.button.DisabledButton': 'Button Disabled',
    'forms.button.LoadingButton': 'Button Loading',
    'forms.button.MultipleButton': 'Multiple Button',
    'forms.button.groupButton': 'Button Group',
    'forms.Tabs.header': 'Tabs',
    'forms.Tabs.simpleTabTitle': 'search',
    'forms.Tabs.simpleTabSubTitle': 'Disabled Tabs',
    'forms.Tabs.iconTabTitle': 'Icon Tabs',
    'forms.Tabs.miniTabTitle': 'Mini Tabs',
    'forms.Tabs.extraTabTitle': 'Extra Action Tabs',
    'forms.Tabs.TabpositionTitle': 'Position',
    'forms.Tabs.TabpositionSubTitle':
        'Tabss position  left   right   top or bottom',
    'forms.Tabs.cardTitle': 'Card Type Tabs',
    'forms.Tabs.editableTitle': 'Add and Close Tabs',
    'forms.Tabs.verticalTitle': 'Vertical Type Tabs',
    'forms.Tabs.basicTitle': 'Basic Tabs',
    'forms.checkbox.header': 'Checkbox',
    'forms.checkbox.basicTitle': 'Basic Checkbox',
    'forms.checkbox.basicSubTitle': 'Basic usage of checkbox.',
    'forms.checkbox.groupTitle': 'Checkbox Group',
    'forms.checkbox.groupSubTitle':
        'Generate a group of checkboxes from an array. Use disabled to disable a checkbox.',
    'forms.checkbox.groupCheckTitle': 'Checkbox Group',
    'forms.checkbox.groupCheckSubTitle':
        'Generate a group of checkboxes from an array. Use disabled to disable a checkbox.',
    'forms.radio.header': 'Radio',
    'forms.radio.simpleTitle': 'Basic Radio',
    'forms.radio.simpleSubTitle':
        'The simplest use. Use disabled to disable a radio.',
    'forms.radio.groupTitle': 'Vertical RadioGroup',
    'forms.radio.groupSubTitle': 'Vertical RadioGroup   with more radios.',
    'forms.radio.groupSecondTitle': 'RadioGroup',
    'forms.radio.groupSecondSubTitle': 'A group of radio components.',
    'forms.radio.groupThirdTitle': 'RadioGroup',
    'forms.radio.groupThirdSubTitle': 'A group of radio components.',
    'forms.transfer.header': 'Transfer',
    'forms.transfer.SubTitle': 'Transfer with a search box.',
    'forms.transfer.Title': 'Search',
    'forms.autocomplete.header': 'Autocomplete',
    'forms.autocomplete.simpleTitle': 'Customized',
    'forms.autocomplete.simpleSubTitle':
        'You could pass AutoComplete.Option as children of AutoComplete   instead of using dataSource',
    'forms.autocomplete.customizeTitle': 'Customize Input Component',
    'forms.autocomplete.customizeSubTitle': 'Customize Input Component',
    'uiElements.badge.badge': 'Badge',
    'uiElements.badge.basicExample': 'Basic Example',
    'uiElements.badge.basicExampleSubTitle':
        'Simplest Usage. Badge will be hidden when count is 0   but we can use showZero to show it.',
    'uiElements.badge.overflowCount': 'Overflow Count',
    'uiElements.badge.overflowCountSubTitle':
        'OverflowCount is displayed when count is larger than overflowCount. The default value of overflowCount is 99.',
    'uiElements.badge.status': 'Status',
    'uiElements.badge.statusSubTitle': 'Standalone badge with status.',
    'uiElements.badge.success': 'Success',
    'uiElements.badge.error': 'Error',
    'uiElements.badge.default': 'Default',
    'uiElements.badge.processing': 'Processing',
    'uiElements.badge.warning': 'Warning',
    'uiElements.badge.redBadge': 'Red badge',
    'uiElements.badge.redBadgeSubTitle':
        'This will simply display a red badge   without a specific count.',
    'uiElements.badge.linkSomething': 'Link something',
    'uiElements.cards.cards': 'Cards',
    'uiElements.cards.basicCard': 'Basic card',
    'uiElements.cards.basicCardSubTitle':
        'A basic card containing a title   content and an extra corner content.',
    'uiElements.cards.more': 'More',
    'uiElements.cards.cardTitle': 'Card Title',
    'uiElements.cards.cardContent': 'Card content',
    'uiElements.cards.lorem':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam   quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    'uiElements.cards.noBorder': 'No Border',
    'uiElements.cards.noBorderSubTitle':
        'A borderless card on a gray background.',
    'uiElements.cards.gridCard': 'Grid card',
    'uiElements.cards.gridCardSubTitle':
        'Cards usually cooperate with grid layout in overview page.',
    'uiElements.cards.loadingCard': 'Loading card',
    'uiElements.cards.loadingCardSubTitle':
        'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.whateverContent': 'Whatever content',
    'uiElements.cards.customizedContentTitle': 'Customized Content',
    'uiElements.cards.customizedContent':
        'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.europeStreetBeat': 'Europe Street beat',
    'uiElements.cards.instagram': 'www.instagram.com',
    'uiElements.carousel.carousel': 'Carousal',
    'uiElements.carousel.verticalCarousel': 'Vertical Carousel',
    'uiElements.carousel.verticalCarouselSubTitle':
        'Vertical pagination. use   vertical=true',
    'uiElements.carousel.basicCarousel': 'Basic Carousel',
    'uiElements.carousel.basicCarouselSubTitle': 'Basic usage',
    'uiElements.carousel.fadeInTransition': 'Fade In Transition',
    'uiElements.carousel.fadeInTransitionSubTitle':
        'Slides use fade for transition.   effect=fade',
    'uiElements.carousel.scrollAutomatically': 'Scroll Automatically',
    'uiElements.carousel.scrollAutomaticallySubTitle':
        'Timing of scrolling to the next card  picture. autoplay',
    'uiElements.collapse.collapse': 'Collapse',
    'uiElements.collapse.collapseSubTitle':
        'More than one panel can be expanded at a time   the first panel is initialized to be active in this case. use   defaultActiveKey=  [keyNum]',
    'uiElements.collapse.text':
        'A dog is a type of domesticated animal. Known for its loyalty and faithfulness   it can be found as a welcome guest in many households across the world.',
    'uiElements.collapse.headerOne': 'This is panel header 1',
    'uiElements.collapse.headerTwo': 'This is panel header 2',
    'uiElements.collapse.headerThree': 'This is panel header 3',
    'uiElements.collapse.headerNested': 'This is panel nest panel',
    'uiElements.collapse.nestedExample': 'Nested Example',
    'uiElements.collapse.nestedExampleSubTitle':
        'Collapse is nested inside the Collapse.',
    'uiElements.collapse.borderlessExample': 'Borderless Example',
    'uiElements.collapse.borderlessExampleSubTitle':
        'A borderless style of Collapse. use   bordered=  false',
    'uiElements.collapse.accordion': 'Accordion',
    'uiElements.collapse.accordionSubTitle':
        'Accordion mode   only one panel can be expanded at a time. The first panel will be expanded by default. use accordion',
    'uiElements.popover.popover': 'Popover',
    'uiElements.popover.basicExample': 'Basic Example',
    'uiElements.popover.basicExampleSubTitle':
        'The most basic example. The size of the floating layer depends on the contents region.',
    'uiElements.popover.hoverMe': 'Hover me',
    'uiElements.popover.title': 'ชื่อสินทรัพย์',
    'uiElements.popover.titleTrigger': 'Three ways to trigger',
    'uiElements.popover.titleTriggerSubTitle':
        'Mouse to click   focus and move in.',
    'uiElements.popover.focusMe': 'Focus me',
    'uiElements.popover.clickMe': 'Click me',
    'uiElements.popover.placement': 'Placement',
    'uiElements.popover.placementSubTitle':
        'There are 12 placement options available.',
    'uiElements.popover.top': 'Top',
    'uiElements.popover.topLeft': 'Top Left',
    'uiElements.popover.topRight': 'Top Right',
    'uiElements.popover.leftTop': 'Left Top',
    'uiElements.popover.left': 'Left',
    'uiElements.popover.leftBottom': 'Left Bottom',
    'uiElements.popover.rightTop': 'Right Top',
    'uiElements.popover.right': 'Right',
    'uiElements.popover.bottom': 'Bottom',
    'uiElements.popover.bottomLeft': 'Bottom Left',
    'uiElements.popover.bottomRight': 'Bottom Right',
    'uiElements.popover.boxTitle': 'Controlling the close of the dialog',
    'uiElements.popover.boxSubTitle':
        'Use visible prop to control the display of the card.',
    'uiElements.popover.TR': 'TR',
    'uiElements.popover.TL': 'TL',
    'uiElements.popover.LT': 'LT',
    'uiElements.popover.LB': 'LB',
    'uiElements.popover.RT': 'RT',
    'uiElements.popover.RB': 'RB',
    'uiElements.popover.BL': 'BL',
    'uiElements.popover.BR': 'BR',
    'uiElements.popover.close': 'Close',
    'uiElements.tooltip.tooltip': 'Tooltip',
    'uiElements.tooltip.tooltipContent': 'Tooltip Content',
    'uiElements.tooltip.basicExample': 'Basic Example',
    'uiElements.tooltip.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.tooltip.placementTitle': 'Placement',
    'uiElements.tooltip.placementSubTitle':
        'The ToolTip has 12 placements choice.',
    'uiElements.tooltip.TL': 'TL',
    'uiElements.tooltip.TR': 'TR',
    'uiElements.tooltip.LT': 'LT',
    'uiElements.tooltip.LB': 'LB',
    'uiElements.tooltip.RT': 'RT',
    'uiElements.tooltip.RB': 'RB',
    'uiElements.tooltip.BL': 'BL',
    'uiElements.tooltip.BR': 'BR',
    'uiElements.tooltip.bottom': 'Bottom',
    'uiElements.tooltip.right': 'Right',
    'uiElements.tooltip.left': 'Left',
    'uiElements.tooltip.top': 'Top',
    'uiElements.tooltip.tooltipContentSpan':
        'Tooltip will show when mouse enter.',
    'uiElements.tooltip.contentSpan': 'Tooltip Content',
    'uiElements.tags.tags': 'Tags',
    'uiElements.tags.basicExample': 'Basic Example',
    'uiElements.tags.basicExampleSubTitle':
        'Usage of basic Tag   and it could be closable by set closable property. Closable Tag supports onClose afterClose events.',
    'uiElements.tags.tagOne': 'Tag 1',
    'uiElements.tags.tagTwo': 'Tag 2',
    'uiElements.tags.link': 'Link',
    'uiElements.tags.preventDefault': 'Prevent Default',
    'uiElements.tags.colorfulTag': 'Colorful Tag',
    'uiElements.tags.hotTags': 'Hot Tags',
    'uiElements.tags.hotTagsSubTitle': 'Select your favourite topics.',
    'uiElements.tags.hots': 'Hots',
    'uiElements.tags.addRemoveDynamically': 'Add & Remove Dynamically',
    'uiElements.tags.addRemoveDynamicallySubTitle':
        'Generating a set of Tags by array   you can add and remove dynamically. Its based on afterClose event   which will be triggered while the close animation end.',
    'uiElements.tags.newTag': '+ New Tag',
    'uiElements.timeline.timeline': 'Timeline',
    'uiElements.timeline.basicExample': 'Basic Example',
    'uiElements.timeline.basicTimeline': 'Basic timeline',
    'uiElements.timeline.lastNode': 'Last Node',
    'uiElements.timeline.lastNodeContent':
        'When the timeline is incomplete and ongoing   put a ghost node at last. set   pending=  true     or   pending=  a React Element',
    'uiElements.timeline.seeMore': 'See more',
    'uiElements.timeline.custom': 'Custom',
    'uiElements.timeline.customContent':
        'Set a node as an icon or other custom element.',
    'uiElements.timeline.colorExample': 'Color Example',
    'uiElements.timeline.colorExampleContent':
        'Set the color of circles. green means completed or success status   red means warning or error   and blue means ongoing or other default status.',
    'uiElements.timeline.createServiceSite': 'Create a services site 2015-09-01',
    'uiElements.timeline.solveInitialNetwork':
        'Solve initial network problems 2015-09-01',
    'uiElements.timeline.networkProblemSolved':
        'Network problems being solved 2015-09-01',
    'uiElements.timeline.technicalTesting': 'Technical testing 2015-09-01',
    'uiElements.dropdown.dropdown': 'Dropdown',
    'uiElements.dropdown.hoverDropdown': 'Hover Drop Down',
    'uiElements.dropdown.hoverMe': 'Hover me',
    'uiElements.dropdown.hoverPlacement': 'Hover Placement Drop Down',
    'uiElements.dropdown.hoverDisableLink': 'Hover Drop Down with Disable link',
    'uiElements.dropdown.clickedDropdown': 'Clicked Drop Down',
    'uiElements.dropdown.buttonDropdown': 'Button with dropdown menu',
    'uiElements.pagination.pagination': 'Pagination',
    'uiElements.pagination.basic': 'Basic',
    'uiElements.pagination.more': 'More',
    'uiElements.pagination.changer': 'Changer',
    'uiElements.pagination.jumper': 'Jumper',
    'uiElements.pagination.miniSize': 'Mini Size',
    'uiElements.pagination.simpleMode': 'Simple Mode',
    'uiElements.pagination.controlled': 'Controlled',
    'uiElements.pagination.totalNumber': 'Total Number',
    'uiElements.rating.rating': 'Rating',
    'uiElements.rating.basicExample': 'Basic Example',
    'uiElements.rating.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.rating.halfStar': 'Half star',
    'uiElements.rating.halfStarSubTitle': 'Support select half star.',
    'uiElements.rating.showCopywriting': 'Show copywriting',
    'uiElements.rating.showCopywritingSubTitle':
        'Add copywriting in rate components.',
    'uiElements.rating.readOnly': 'Read only',
    'uiElements.rating.readOnlySubTitle':
        'Read only   cant use mouse to interact.',
    'uiElements.rating.otherCharacter': 'Other Character',
    'uiElements.rating.otherCharacterSubTitle':
        'Replace the default star to other character like alphabet   digit   iconfont or even Chinese word.',
    'uiElements.tree.tree': 'Tree',
    'uiElements.tree.basicExample': 'Basic example',
    'uiElements.tree.basicExampleSubTitle':
        'The most basic usage   tell you how to use checkable   selectable   disabled   defaultExpandKeys   and etc.',
    'uiElements.tree.basicControlledExample': 'Basic controlled example',
    'uiElements.tree.basicControlledExampleSubTitle': 'basic controlled example',
    'uiElements.tree.draggableExample': 'Draggable example',
    'uiElements.tree.draggableExampleSubTitle':
        'Drag treeNode to insert after the other treeNode or insert into the other parent TreeNode.',
    'uiElements.tree.loadAsync': 'Load data asynchronously',
    'uiElements.tree.loadAsyncSubTitle':
        'To load data asynchronously when click to expand a treeNode.',
    'uiElements.tree.searchableExample': 'Searchable example',
    'uiElements.tree.searchableExampleSubTitle': 'Searchable Tree',
    'uiElements.tree.treeWithLine': 'Tree With Line',
    'shuffle.descriptionOne': 'Netscape 2.0 ships   introducing Javascript',
    'shuffle.descriptionTwo': 'Jesse James Garrett releases AJAX spec',
    'shuffle.descriptionThree': 'jQuery 1.0 released',
    'shuffle.descriptionFour': 'First underscore.js commit',
    'shuffle.descriptionFive': 'Backbone.js becomes a thing',
    'shuffle.descriptionSix': 'Angular 1.0 released',
    'shuffle.descriptionSeven': 'React is open-sourced; developers rejoice',
    'toggle.list': 'List',
    'toggle.grid': 'Grid',
    'toggle.ascending': 'Ascending',
    'toggle.descending': 'Descending',
    'toggle.shuffle': 'Shuffle',
    'toggle.rotate': 'Rotate',
    'toggle.addItem': 'Add Item',
    'toggle.removeItem': 'Remove Item',
    'contactlist.searchContacts': 'Search Contacts',
    'contactlist.addNewContact': 'เพิ่มชื่อผู้ติดต่อ',
    'notes.ChoseColor': 'Choose a color for your note',
    'notes.addNote': 'Add New Note',
    'page404.title': '404',
    'page404.subTitle': 'Looks like you got lost',
    'page404.description':
        'The page youre looking for doesnt exist or has been moved.',
    'page404.backButton': 'BACK HOME',
    'page500.title': '500',
    'page500.subTitle': 'Internal Server Error',
    'page500.description': 'Something went wrong. Please try again later.',
    'page500.backButton': 'BACK HOME',
    'page.forgetPassTitle': 'Isomorphic',
    'page.forgetPassSubTitle': 'Forgot Password?',
    'page.forgetPassDescription':
        'Enter your email and we send you a reset link.',
    'page.sendRequest': 'Send request',
    'page.resetPassTitle': 'Isomorphic',
    'page.resetPassSubTitle': 'Reset Password',
    'page.resetPassDescription': 'Enter new password and confirm it.',
    'page.resetPassSave': 'Save',
    'page.signInTitle': 'SAGA PROPERTY',
    'page.signInRememberMe': 'Remember me',
    'page.signInButton': 'เข้าสู่ระบบ',
    'page.signInPreview':
        'username: demo   password: demodemo   or just click on any button.',
    'page.signInFacebook': 'Sign in with Facebook',
    'page.signInGooglePlus': 'Sign in with Google Plus',
    'page.signInAuth0': 'Sign in with Auth0',
    'page.signInForgotPass': 'Forgot password',
    'page.signInCreateAccount': 'Create an Isomorphoic account',
    'page.signUpTitle': 'Isomorphic',
    'page.signUpTermsConditions': 'I agree with terms and condtions',
    'page.signUpButton': 'Sign Up',
    'page.signUpFacebook': 'Sign up with Facebook',
    'page.signUpGooglePlus': 'Sign up with Google Plus',
    'page.signUpAuth0': 'Sign Up with Auth0',
    'page.signUpAlreadyAccount': 'Already have an account? Sign in.',
    'widget.reportswidget.label': 'Income',
    'widget.reportswidget.details':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor',
    'widget.singleprogresswidget1.label': 'Marketing',
    'widget.singleprogresswidget2.label': 'Addvertisement',
    'widget.singleprogresswidget3.label': 'Consulting',
    'widget.singleprogresswidget4.label': 'Development',
    'widget.stickerwidget1.number': '210',
    'widget.stickerwidget1.text': 'Unread Email',
    'widget.stickerwidget2.number': '1749',
    'widget.stickerwidget2.text': 'Image Upload',
    'widget.stickerwidget3.number': '3024',
    'widget.stickerwidget3.text': 'Total Message',
    'widget.stickerwidget4.number': '54',
    'widget.stickerwidget4.text': 'Orders Post',
    'widget.salewidget1.label': 'Income',
    'widget.salewidget1.price': '$15000',
    'widget.salewidget1.details':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor',
    'widget.salewidget2.label': 'Income',
    'widget.salewidget2.price': '$15000',
    'widget.salewidget2.details':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor',
    'widget.salewidget3.label': 'Income',
    'widget.salewidget3.price': '$15000',
    'widget.salewidget3.details':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor',
    'widget.salewidget4.label': 'Income',
    'widget.salewidget4.price': '$15000',
    'widget.salewidget4.details':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor',
    'widget.cardwidget1.number': '110',
    'widget.cardwidget1.text': 'New Messages',
    'widget.cardwidget2.number': '100%',
    'widget.cardwidget2.text': 'Volume',
    'widget.cardwidget3.number': '137',
    'widget.cardwidget3.text': 'Achievement',
    'widget.progresswidget1.label': 'Download',
    'widget.progresswidget1.details': '50% Complete',
    'widget.progresswidget2.label': 'Support',
    'widget.progresswidget2.details': '80% Satisfied Customer',
    'widget.progresswidget3.label': 'Upload',
    'widget.progresswidget3.details': '65% Complete',
    'widget.vcardwidget.name': 'Jhon Doe',
    'widget.vcardwidget.title': 'Sr. iOS Developer',
    'widget.vcardwidget.description':
        'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor ammet dolar consectetur adipisicing elit',
    'checkout.billingform.firstname': 'First Name',
    'checkout.billingform.lastname': 'Last Name',
    'checkout.billingform.company': 'Company Name',
    'checkout.billingform.email': 'Email Address',
    'checkout.billingform.mobile': 'Mobile No',
    'checkout.billingform.country': 'ประเทศ',
    'checkout.billingform.city': 'City',
    'checkout.billingform.address': 'Address',
    'checkout.billingform.addressoptional':
        'Apartment   suite   unit etc. (optional',
    'checkout.billingform.checkbox': 'Create an account?',
    'antTable.title.image': 'Image',
    'antTable.title.firstName': 'First Name',
    'antTable.title.lastName': 'Last Name',
    'antTable.title.city': 'City',
    'antTable.title.street': 'Street',
    'antTable.title.email': 'Email',
    'antTable.title.dob': 'DOB',
    'Map.leaflet.basicTitle': 'Basic Map',
    'Map.leaflet.basicMarkerTitle': 'Basic Map(With Default Marker',
    'Map.leaflet.leafletCustomMarkerTitle': 'Basic Map(With Custom Icon Marker)',
    'Map.leaflet.leafletCustomHtmlMarkerTitle':
        'Basic Map(With Custom Html Marker',
    'Map.leaflet.leafletMarkerClusterTitle': 'Basic Map(With Marker Cluster',
    'Map.leaflet.leafletRoutingTitle': 'Basic Map Routing',
    'Component.contacts.noOption': 'No contact found',
    'email.send': 'SEND',
    'email.cancel': 'CANCEL',
    'email.compose': 'COMPOSE',
    'email.noMessage': 'Please select a mail to read',
    'themeSwitcher.purchase': 'PURCHAGE NOW',
    'themeSwitcher.settings': 'Settings',
    'sidebar.selectbox': 'Select',
    'sidebar.frappeChart': 'Frappe Charts',
    'topbar.help': 'Help',
    'topbar.logout': 'Logout',
    'topbar.viewAll': 'View All',
    'topbar.viewCart': 'View Cart',
    'topbar.totalPrice': 'Total Price',
    'modalConfirm.button.confirm': 'ยืนยัน',
    'modalConfirm.button.ContinueAnyWay': 'ดำเนินการต่อ',
    'modalConfirm.button.cancel': 'ยกเลิก',
    'commission.title.agentName': 'พนักงานขาย',
    'commission.title.commission': 'คอมมิชชั่น',
    'offer.date': 'วันที่',
    'offer.documentName': 'ชื่อเอกสาร',
    'offer.offerName': 'ข้อเสนอ',
    'offer.agentName': 'ตัวแทนการขาย',
    'offer.createOffer': 'เพิ่มข้อเสนอ',
    'offer.createContract': 'สร้างสัญญา',
    'offer.detail.header.detail': 'รายละเอียด',
    'offer.detail.header.amount': 'จำนวนเงิน',
    'offer.detail.header.validityPeriod': 'ระยะเวลาที่มีผล',
    'offer.detail.header.buyerInformation': 'ข้อมูลผู้ซื้อ',
    'offer.detail.header.sellerInformation': 'ข้อมูลผู้ขาย',
    'offer.detail.header.sellerAndBuyerInformation': 'ข้อมูลผู้ขาย/ผู้ซื้อ',
    'offer.detail.header.sellingInformationWillPullFromPropertyOwner': 'ข้อมูลผู้ขายจะถูกแสดงตามข้อมูลเจ้าของทรัพย์สิน',
    'offer.detail.name': 'ชื่อข้อเสนอ',
    'offer.detail.insuranceCompany': 'ชื่อบริษัทประกันภัย',
    'offer.detail.pleaseSelectInsuranceCompany': 'เลือกบริษัทประกันภัย',
    'offer.detail.offerStatus': 'สถานะข้อเสนอ',
    'offer.detail.contract': 'สัญญา',
    'offer.detail.contract.createFromThisOffer': 'สร้างสัญญาจากข้อเสนอนี้',
    'offer.detail.contract.cannotCreateContractFromthisOffer': 'ไม่สามารถสร้างสัญญาจากข้อเสนอที่ถูกปฏิเสธได้',
    'offer.detail.offeredPrice': 'ราคาเสนอ',
    'offer.detail.deposit': 'ฝาก',
    'offer.detail.validFrom': 'ข้อเสนอเริ่มต้นวันที่',
    'offer.detail.validUntil': 'มีผลถึงวันที่',
    'offer.status.firstOffer': 'ข้อเสนอแรก',
    'offer.status.counterOffer': 'ข้อเสนอเพื่อจูงใจ',
    'offer.status.acceptedOffer': 'ข้อเสนอที่ได้รับการยอมรับ',
    'offer.status.declinedOffer': 'ข้อเสนอที่ถูกปฏิเสธ',
    'offer.button.update': 'แก้ไข',
    'offer.button.create': 'สร้างข้อเสนอ',
    'offer.description.buyerProvision': 'หมายเหตุผู้ซื้อ',
    'offer.description.ownerProvision': 'หมายเหตุผู้ขาย',
    'offer.description.backside':'สลักหลัง',
    'offer.description.documentTemplate':'ฟอร์มเอกสาร',
    'offer.payment':'การชำระเงิน',
    'offer.payment.appraisal': 'ราคาประเมิน',
    'offer.payment.propertyAppraisal':'ราคาประเมินอสังหาฯ',
    'offer.payment.loanDisclaimer':'หมายเหตุสินเชื่อ',
    'buyerInformation.name': 'ชื่อ',
    'buyerInformation.homePhone': 'เบอร์โทรศัพท์บ้าน',
    'buyerInformation.nationalId': 'เลขประจำตัวประชาชน',
    'buyerInformation.workPhone': 'เบอร์โทรศัพท์ที่ทำงาน',
    'buyerInformation.address': 'ที่อยู่',
    'buyerInformation.mobilePhone': 'เบอร์โทรศัพท์มือถือ',
    'buyerInformation.ownerPercent': '% ความเป็นเจ้าของ',
    'buyerInformation.lineId': 'ไลน์ไอดี',
    'buyerInformation.email': 'อีเมล์',
    'buyerInformation.addOneMoreBuyer': 'เพิ่มข้อมูลผู้ซื้อ',
    'buyerInformation.addOneMoreRenter': 'เพิ่มข้อมูลผู้เช่า',
    'buyerInformation.notFoundContact': 'ไม่พบข้อมูล (กรุณาเพิ่มข้อมูลในหัวข้อผู้ติดต่อก่อน)',
    'buyerInformation.signature': 'ลายเซ็นต์',
    'buyerInformation.hideBuyerName': 'ซ่อนชื่อ',
    'buyerInformation.displayInBuyerList': 'แสดงข้อมูลผู้ซื้อ',
    'buyerInformation.displayInSellerList': 'แสดงข้อมูลผู้ขาบ',
    'buyerInformation.displaySignature': 'แสดงลายเซ็นต์',

    // OWNER MODULE
    'OwnerInformation.addOneMoreOwner': 'เพิ่มข้อมูลผู้ขาย',

    // CONTRACT MODULE
    'contract.contractPrice': 'ราคา',
    'contract.menu.contractDetail': 'รายละเอียดสัญญา',
    'contract.menu.paymentBreakdown': 'การชำระเงิน',
    'contract.menu.text': 'สัญญา',
    'contract.menu.commission': 'คอมมิชชั่น',
    'contract.menu.history': 'ประวัติ',
    'contract.menu.deedDetail': 'ข้อมูลการมอบสิทธิ์',
    'contract.menu.deedDescription': 'รายละเอียด',
    'contract.detail.title.contractDetail': 'รายละเอียดสัญญา',
    'contract.detail.contractName': 'ชื่อสัญญา',
    'contract.detail.insuranceCompany': 'ชื่อบริษัทประกันภัย',
    'contract.detail.associatedOffer': 'ข้อเสนอที่เกี่ยวข้อง',
    'contract.detail.contractDate': 'วันที่ทำสัญญา',
    'contract.detail.transferDate': 'วันที่โอน',
    'contract.detail.deedDate': 'วันมอบทรัพย์',
    'contract.detail.transferDateText': 'วันที่โอน(หมายเหตุ)',
    'contract.detail.previousDeedDue': 'วันครบกำหนดจ่ายล่าสุด',
    'contract.detail.title.buyerInfomation': 'ผู้ซื้อ',
    'contract.detail.enterContractName': 'ชื่อสัญญา',
    'contract.paymentBreakdown.title.paymentBreakdown': 'การชำระเงิน',
    'contract.paymentBreakdown.propertyAppraisal': 'ราคาประเมินอสังหาริมทรัพย์',
    'contract.paymentBreakdown.fireAppraisal': 'Fire Appraisal',
    'contract.paymentBreakdown.landAppraisal': 'ราคาประเมินที่ดิน',
    'contract.text.title.frontSideText': 'ด้านหน้าสัญญา',
    'contract.text.title.buyerConditions': 'สัญญาผู้ซื้อ',
    'contract.text.title.sellerConditions': 'สัญญาผู้ขาย',
    'contract.text.title.backSideText': 'ด้านหลังสัญญา',
    'contract.text.templates': 'รูปแบบสัญญา',
    'contract.text.signningLcation': 'สถานทีทำสัญญา',
    'contract.commission.title.commissionDistribution': 'แบ่งค่าคอมมิชชั่น',
    'contract.commission.title.PaymentReceived': 'บันทึกรับชำระเงิน',
    'contract.commission.commissionPercent': 'ค่าคอมมิชชั่น (%)',
    'contract.commission.commissionFixed': 'ค่าคอมมิชชั่น (บาท)',
    'contract.commission.commissionTotal': 'รวมค่าคอมมิชชั่น',
    'contract.commission.receiver': 'ผู้รับ',
    'contract.commission.fixed': 'คงที่',
    'contract.commission.total': 'รวม',
    'contract.commission.grandTotal': 'สุทธิ',
    'contract.commission.receivedOn': 'วันที่ได้รับ',
    'contract.history.title.history': 'ประวัติ',
    'contract.history.createOn': 'วันที่',
    'contract.history.agentName': 'ตัวแทนการขาย',
    'contract.history.action': 'ประวัติ',
    'excelList.header.allEmployeeCommission': 'All employee commission',
    'excelList.button.exportExcel': 'Export Excel',
    'contract.createDeed': 'มอบสิทธิ์',
    'contract.deed.deedPrice': 'ราคาโฉนด',
    'contract.deed': 'มอบสิทธิ์',
    'contract.deed.deedDetail': 'ข้อมูลการมอบสิทธิ์',
    'contract.deed.deedName': 'Deed Name',
    'contract.deed.enterDeedName': 'Deed Name',
    'contract.deed.deedDescription': 'รายละเอียดการมอบสิทธ์',
    'contract.deed.insurance': 'ชื่อบริษัทประกันภัย',
    'contract.deed.buyerProvision': 'หมายเหตุผู้ซื้อ',
    'contract.deed.ownerProvision': 'หมายเหตุผู้ขาย',
    'contract.deed.salesRepresentative': 'ตัวแทนการขาย',
    'contract.deed.enterBuyerProvision': 'Enter Buyer Provision',
    'contract.deed.enterOwnerProvision': 'Enter Owner Provision',
    'contract.deed.paymentBreakdown.title.paymentBreakdown': 'การชำระเงิน',
    'contract.deed.paymentBreakdown.propertyAppraisal': 'ราคาประเมินอสังหาริมทรัพย์',
    'contract.deed.paymentBreakdown.fireAppraisal': 'ราคาประเมินอัคคีภัย',
    'contract.deed.paymentBreakdown.landAppraisal': 'ราคาประเมินที่ดิน',
    'contract.deed.paymentBreakdown.DeliveryDateText': 'วันที่ส่งมอบ',
    'contract.deed.paymentBreakdown.DeliveryDate': 'วันส่งมอบ (หมายเหตุ)',
    'contract.deed.paymentBreakdown.OfferPrice': 'ข้อเสนอราคา',
    'contract.deed.paymentBreakdown.Town': 'สถานที่ลงนาม',
    'contract.deed.paymentBreakdown.SignDate': 'วันที่ลงนาม',
    'contract.deed.paymentBreakdown.ContractDate': 'วันที่ทำสัญญา',
    'contract.deed.paymentBreakdown.DeedDate': 'Deed Date',
    'contract.deed.paymentBreakdown.TransferDate': 'Transfer Date',
    'contract.deed.paymentBreakdown.PreviousDeedDate': 'Previous Deed Due',
    'contract.deed.paymentBreakdown.rentPeriod': 'ระยะเวลา การเช่า',
    'contract.deed.paymentBreakdown.advancePayment': 'เงินจ่ายล่วงหน้า',
    'contract.deed.paymentBreakdown.paymentFrequency': 'รอบการจ่าย',
    'contract.deed.paymentBreakdown.moveInDate': 'วันที่ย้ายเข้า',
    'contract.deed.paymentBreakdown.moveInDateText': 'วันที่ย้ายเข้า (หมายเหตุ)',
    'contract.deed.associatedContract': 'สัญญาที่เกี่ยวข้อง',
    'property.description': 'รายละเอียด',
    'property.description.full': 'รายละเอียดอสังหาริมทรัพย์',
    'property.description.forReport': 'รายละเอียดอสังหาริมทรัพย์ (SAGA)',
    'property.description.renovetions': 'ปรับปรุง',
    'property.description.knownDefects': 'Known defects',
    'property.description.openHouse': 'เปิดชม',
    'property.description.from': 'จาก',
    'property.description.to': 'ถึง',
    'property.description.advertisement': 'รายละเอียดโฆษณา',
    'property.description.button.getStandardText': 'ใช้ข้อความมาตรฐาน',
    'property.description.button.saveStandardText': 'บันทึกข้อความมาตรฐาน',
    'property.description.button.save': 'บันทึก',

    // SETTING MODULE
    'setting.menu.enquiry.status': 'ผู้ติดต่อ/ความต้องการลูกค้า',
    'setting.menu.project.status': 'โปรเจกค์',
    'setting.menu.employee.status': 'พนักงาน',
    'setting.menu.office.status': 'ออฟฟิศ',
    'setting.menu.propertyAndProject.status': 'สินทรัพย์และโปรเจค',
    'setting.menu.sale.status': 'งานขาย',
    'setting.menu.employee.detail': 'รายละเอียดพนักงาน',
    'setting.menu.employee.passwordAndAuthentication': 'สิทธิ์/ข้อมูลที่แสดงสู่สาธารณะ',
    'setting.menu.employee.salesHistory': 'ประวัติการขาย',
    'setting.text.title.statusName': 'สถานะ',
    'setting.text.title.statusDetail': 'รายละเอียด',
    'setting.text.title.sourceName': 'ที่มา',
    'setting.propertyAndProject.header.defect': 'ข้อเสียหาย',
    'setting.propertyAndProject.header.delivery': 'การส่งมอบอสังหาฯ',
    'setting.propertyAndProject.header.documentTemplate': 'ฟอร์มเอกสาร',
    'setting.propertyAndProject.header.entrance': 'ทางเข้า',
    'setting.propertyAndProject.header.heating': 'ระบบทำความร้อน',
    'setting.propertyAndProject.header.index': 'ดัชนีอสังหาฯ',
    'setting.propertyAndProject.header.commercialIndex': 'ดัชนีอสังหาฯ เชิงพาณิชย์',
    'setting.propertyAndProject.header.insurance': 'ประกัน',
    'setting.propertyAndProject.header.language': 'ภาษา',
    'setting.propertyAndProject.header.material': 'วัสดุ',
    'setting.propertyAndProject.header.mortgagee': 'ผู้รับจำนอง',
    'setting.propertyAndProject.header.propertyType': 'ประเภทอสังหาฯ',
    'setting.propertyAndProject.header.livingPropertyType': 'ประเภทอสังหาฯ แบบที่อยู่อาศัย',
    'setting.propertyAndProject.header.commercialPropertyType': 'ประเภทอสังหาฯ เชิงพาณิชย์',
    'setting.propertyAndProject.header.status': 'สถานะ',
    'setting.propertyAndProject.header.projectStatus': 'สถานะโครงการ',
    'setting.propertyAndProject.header.propertyStatus': 'สถานะอสังหาฯ',
    'setting.propertyAndProject.header.source': 'แหล่งที่มา',
    'setting.propertyAndProject.header.projectSource': 'แหล่งที่มาของโครงการ',
    'setting.propertyAndProject.header.propertySource': 'แหล่งที่มาของอสังหาฯ',
    'setting.propertyAndProject.header.usage': 'ประเภทใช้สอย',
    'setting.propertyAndProject.header.window': 'หน้าต่าง',
    'setting.propertyAndProject.table.item': 'รายการ',
    'setting.propertyAndProject.table.desc': 'รายละเอียด',
    'setting.enquiry.header.source': 'แหล่งที่มา',
    'setting.enquiry.header.source.contact': 'แหล่งที่มาของผู้ติดต่อ',
    'setting.enquiry.header.source.enquiry': 'แหล่งที่มาของลูกค้า',
    'setting.salesCommission.header.Commission': 'คอมมิชชั่น',
    'setting.salesCommission.header.title': 'ตารางจ่ายค่าคอมมิชชั่น',
    'setting.salesCommission.table.accumulateSalesFrom': 'ยอดคอมมิชชั่นสะสมเริ่มต้น',
    'setting.salesCommission.table.accumulateSalesTo': 'ถึงยอดคอมมิชชั่นสะสม',
    'setting.salesCommission.table.commissionRate': 'ส่วนแบ่งค่าคอมมิชชั่น',
    'setting.salesCommission.button.edit': 'แก้ไข',
    'setting.salesCommission.button.delete': 'ลบ',
    'setting.salesCommission.button.add': 'เพิ่ม',
    'setting.salesCommission.button.updateCommission': 'แก้ไขคอมมิชชั่น',

    'setting.documentTemplate.text': 'แบบฟอร์มเอกสาร',
    'setting.documentTemplate.name': 'ชื่อเอกสาร',
    'setting.documentTemplate.type': 'ประเภทเอกสาร',
    'setting.documentTemplate.docType': 'ประเภทเอกสาร',
    'setting.documentTemplate.docType.offer': 'ข้อเสนอ',
    'setting.documentTemplate.docType.contract': 'สัญญา',
    'setting.documentTemplate.newDoc': 'แบบฟอร์มเอกสารใหม่',

    'setting.documentTemplate.dynamicTag': 'แทรกข้อมูลแบบไดนามิก',
    'setting.documentTemplate.propertyname': 'ชื่อทรัพย์',
    'setting.documentTemplate.propertyprice': 'ราคาทรัพย์',
    'setting.documentTemplate.propertypricetext': 'ราคาทรัพย์ (ตัวอักษร)',
    'setting.documentTemplate.propertyaddress': 'ที่อยู่ 1',
    'setting.documentTemplate.propertyaddress2': 'ที่อยู่ 2',
    'setting.documentTemplate.propertyhousenumber': 'เลขที่บ้าน',
    'setting.documentTemplate.propertysize': 'พื้นที่ใช้สอย',
    'setting.documentTemplate.propertyfloor': 'จำนวนชั้น',
    'setting.documentTemplate.propertydeedno': 'เลขที่โฉนด',
    'setting.documentTemplate.propertyowner': 'เจ้าของทรัพย์',
    'setting.documentTemplate.propertyownerall': 'เจ้าของทรัพย์ทั้งหมด',
    'setting.documentTemplate.documentname': 'ชื่อเอกสาร',
    'setting.documentTemplate.sellprice': 'ราคาขายตามสัญญา',
    'setting.documentTemplate.buyername': 'ผู้ซื้อ',
    'setting.documentTemplate.buyernameall': 'ผู้ซื้อทั้งหมด',
    'setting.documentTemplate.buyerid': 'หมายเลขบัตรประชาชนผู้ซื้อ',
    'setting.documentTemplate.buyeridall': 'หมายเลขบัตรประชาชนผู้ซื้อทั้งหมด',
    'setting.documentTemplate.transferdate': 'วันโอน',
    'setting.documentTemplate.contractdate': 'วันที่ทำสัญญา',
    'setting.documentTemplate.deeddate': 'วันมอบทรัพย์',
    'setting.documentTemplate.previousdeeddue': 'วันครบกำหนดจ่ายล่าสุด',
    'setting.documentTemplate.paymentrec1': 'ยอดชำระ #1',
    'setting.documentTemplate.paymentrec2': 'ยอดชำระ #2',
    'setting.documentTemplate.paymentsummary': 'ยอดรวมชำระ',
    'setting.documentTemplate.mortgagesummary': 'ยอดรวมเงินกู้',
    'setting.documentTemplate.ilssummary': 'ยอดรวมสินเชื่อเพื่อการเคหะ',
    'setting.documentTemplate.ilsextrasummary': 'ยอดรวมสินเชื่อเพื่อการเคหะ (เพิ่มเติม)',
    'setting.documentTemplate.newloansummary': 'ยอดรวมเงินกู้ใหม่',
    'setting.documentTemplate.bondsummary': 'ยอดรวมพันธบัตร',
    'setting.documentTemplate.allpaymentsummary': 'ยอดรวมชำระทั้งสิ้น',
    'setting.documentTemplate.ownerid': 'หมายเลขบัตรประชาชนเจ้าของ',
    'setting.documentTemplate.owneridall': 'หมายเลขบัตรประชาชนเจ้าของทั้งหมด',

    'setting.documentTemplate.propertyownerphone': 'เบอร์โทรศัพท์เจ้าของทรัพย์',
    'setting.documentTemplate.buyerphone': 'เบอร์โทรศัพท์ผู้ซื้อ',
    'setting.documentTemplate.propertyowneremail': 'อีเมลเจ้าของทรัพย์',
    'setting.documentTemplate.buyeremail': 'อีเมลผู้ซื้อ',
    'setting.documentTemplate.propertyowneraddress': 'ที่อยู่เจ้าของทรัพย์',
    'setting.documentTemplate.buyeraddress': 'ที่อยู่ผู้ซื้อ',
    'setting.documentTemplate.propertyownerage': 'อายุเจ้าของทรัพย์',
    'setting.documentTemplate.buyerage': 'อายุผู้ซื้อ',
    'setting.documentTemplate.offerstartdate': 'วันที่เริ่มข้อเสนอ',
    'setting.documentTemplate.offerenddate': 'วันที่สิ้นสุดข้อเสนอ',
    'setting.documentTemplate.offerstartdatebe': 'วันที่เริ่มข้อเสนอ (พ.ศ.)',
    'setting.documentTemplate.offerenddatebe': 'วันที่สิ้นสุดข้อเสนอ (พ.ศ.)',
    'setting.documentTemplate.contractdatebe': 'วันที่ทำสัญญา (พ.ศ.)',
    'setting.documentTemplate.transferdatebe': 'วันโอน (พ.ศ.)',
    'setting.documentTemplate.deeddatebe': 'วันมอบทรัพย์ (พ.ศ.)',
    'setting.documentTemplate.propertylandsize': 'ขนาดที่ดิน',
    'setting.documentTemplate.propertylandsizeth': 'ขนาดที่ดิน (มาตราวัดไทย)',
    'setting.documentTemplate.landnumber': 'หมายเลขที่ดิน',
    'setting.documentTemplate.salename': 'ชื่อพนักงานขาย',
    'setting.documentTemplate.salephone': 'เบอร์โทรศัพท์พนักงานขาย',
    'setting.documentTemplate.propertycommission': 'เปอร์เซนคอมมิชชั่น',
    'setting.documentTemplate.propertycommissionfixed': 'คอมมิชชั่นคงที่',
    'setting.documentTemplate.propertyexpiredate': 'วันสิ้นสุดตัวแทน',
    'setting.documentTemplate.currentdate': 'วันที่ปัจจุบัน',
    'setting.documentTemplate.currentdatebe': 'วันที่ปัจจุบัน พ.ศ.',
    'setting.documentTemplate.signplace': 'สถานที่ลงนาม',
    'setting.documentTemplate.saleaddress': 'ที่อยู่พนักงานขาย',
    'setting.documentTemplate.saleage': 'อายุพนักงานขาย',
    'setting.documentTemplate.propertyexpiredatebe': 'วันสิ้นสุดตัวแทน (พ.ศ.)',
    
    'setting.office.officeName': 'ชื่อสำนักงาน',
    'setting.office.companyId': 'รหัสสำนักงาน',
    'setting.office.postalAddress': 'เมือง',
    'setting.office.general': 'ทั่วไป',
    'setting.office.phoneNumber': 'เบอร์โทรศัพท์',
    'setting.office.altAddress': 'ที่อยู่สำรอง',
    'setting.office.faxNumber': 'เบอร์แฟกซ์',
    'setting.office.sagaOfficeId': 'รหัสสาขา',
    'setting.office.website': 'เว็บไซต์',
    'setting.office.showOnWeb': 'แสดงรายละเอียดบนเว็บไซต์',
    'setting.office.agentIsolation': 'แยกการแสดงข้อมูลพนักงานขาย',
    'setting.office.allowTextSelection': 'อนุญาตเลือกข้อความ',
    'setting.office.allowProjectList': 'แสดงโครงการ',
    'setting.office.showQuickView': 'แสดงข้อมูลย่อของทรัพย์',
    'setting.office.showAgentDirectCall': 'Show agent direct call',
    'setting.office.agentMapUrl': 'Agent Map Url',
    'setting.office.slogan': 'สโลแกน',
    'setting.office.closer': 'ใกล้เคียง',
    'setting.office.marketingBullet1': 'นโยบายการตลาด 1',
    'setting.office.marketingBullet2': 'นโยบายการตลาด 2',
    'setting.office.marketingBullet3': 'นโยบายการตลาด 3',
    'setting.office.reportLogo': 'โลโก้รายงาน',
    'setting.office.webLogo': 'โลโก้เว็บไซต์',
    'setting.office.waterMark': 'ลายน้ำ',
    'setting.office.defaultProperty': 'สินทรัพย์เริ่มต้น',
    'setting.office.officeDetail': 'รายละเอียดสำนักงาน',
    'setting.office.buyerCosts': 'Buyer Costs',
    'setting.office.loanCost': 'Loan Cost',
    'setting.office.stampDutyContract': 'Stamp duty for contract',
    'setting.office.notarizingContract': 'Notarizing of contract',
    'setting.office.loanCostOfExtraLoan': 'Loan cost of extra loan',
    'setting.office.stampDutyForLoan': 'Stamp duty for loan',
    'setting.office.notarizingOfLoan': 'Notarizing of loan',
    'setting.office.officeCost': 'Office cost',
    'setting.office.fmrEnabled': 'FMR Enabled',
    'setting.office.fmrAddress': 'FMR address',
    'setting.office.cityID': 'City ID',
    'setting.office.admakerAddress': 'Admaker address',
    'setting.office.integratorId': 'Integrator ID',
    'setting.office.regionId': 'Region ID',
    'setting.office.trixboxAddress': 'Trixbox Address',
    'setting.office.integratorOfficeId': 'Integrator Office ID',
    'setting.office.intlOfficeId': 'Intl Office ID',
    'setting.office.externalPortal': 'External/Portal',
    'setting.office.portal': 'ชื่อ',
    'setting.office.portalName': 'ประเภท',
    'setting.office.email': 'อีเมล์',
    'setting.office.public': 'Public',
    'setting.office.enable': 'Enabled',
    'setting.office.csEnable': 'CS Enabled',
    'setting.office.default': 'Default',
    'setting.office.userName': 'ชื่อผู้ใช้งาน',
    'setting.office.password': 'รหัสผ่าน',
    'setting.office.url': 'URL',
    'setting.office.darkpoolID': 'Darkpool ID',
    'setting.office.darkpoolKey': 'Darkpool Key',
    'setting.office.sendUsers': 'Send Users',
    'setting.office.sendProperty': 'Send Properties',
    'setting.office.darkpoolAddress': 'Darkpool Address',
    'setting.office.darkpoolAddressNote': 'Please note that putting colon (:) symbol at any place in address will cut the address at that position when sending to web.',
    'setting.office.darkpoolAddressFormat': 'Address Format',
    'setting.office.sendAsInSagaEign': 'Send as it is in SagaEign',
    'setting.office.sendOnlyStreetName': 'Send only street name',
    'setting.employee.header.id': 'ID',
    'setting.employee.header.userName': 'ชื่อผู้ใช้',
    'setting.employee.header.name': 'ชื่อ',
    'setting.employee.header.role': 'ตำแหน่ง',
    'setting.employee.header.email': 'อีเมล์',
    'setting.employee.header.mobilePhone': 'เบอร์โทรศัพท์',
    'setting.employee.header.status': 'สถานะ',
    'setting.employee.showInactiveUser': 'แสดงผู้ใช้ที่ไม่ได้ใช้งาน',
    'setting.employee.addNewEmployee': 'สร้างผู้ใช้งานใหม่',
    'setting.employee.detail.general': 'ข้อมูลทั่วไป',
    'setting.employee.detail.firstName': 'ชื่อจริง',
    'setting.employee.detail.middleName': 'ชื่อกลาง',
    'setting.employee.detail.lastName': 'นามสกุล',
    'setting.employee.detail.ssn': 'เลขบัตรประจำตัวประชาชน',
    'setting.employee.detail.dateOfBirth': 'วันเกิด',
    'setting.employee.detail.gender': 'เพศ',
    'setting.employee.detail.lineId': 'ไลน์ไอดี',
    'setting.employee.detail.lineQR': 'ไลน์ QR',
    'setting.employee.detail.workNumber': 'เบอร์โทรศัพท์ที่ทำงาน',
    'setting.employee.detail.mobileNumber': 'เบอร์โทรศัพท์มือถือ',
    'setting.employee.detail.mobileNumber2': 'เบอร์โทรศัพท์มือถือ 2',
    'setting.employee.detail.otherNumber': 'เบอร์โทรศัพท์อื่นๆ',
    'setting.employee.detail.website': 'เว็บไซต์',
    'setting.employee.detail.publishing': 'ข้อมูลที่แสดงสู่สาธารณะ',
    'setting.employee.detail.showEmployeeDetailOnWeb': 'แสดงรายละเอียดพนักงานบนเว็บ',
    'setting.employee.detail.showPictureInSalesReport': 'แสดงรูปภาพในรายงานการขาย',
    'setting.employee.detail.showPictureInPropertyList': 'แสดงรูปภาพในสินทรัพย์ทั้งหมด',
    'setting.employee.detail.job': 'อาชีพ',
    'setting.employee.detail.titile': 'ตำแหน่ง',
    'setting.employee.detail.teamStatus': 'สถานะในทีม',
    'setting.employee.detail.slogan': 'สโลแกน',
    'setting.employee.detail.closer': 'Closer',
    'setting.employee.detail.languages': 'ภาษา',
    'setting.employee.detail.specialities': 'Specialities',
    'setting.employee.detail.educations': 'การศึกษา',
    'setting.employee.detail.description': 'รายละเอียด',
    'setting.employee.detail.marketingBullet1': 'Marketing Bullet 1',
    'setting.employee.detail.agentId': 'รหัสพนักงาน',
    'setting.employee.detail.sagaUserId': 'รหัสผู้ใช้ SAGA',
    'setting.employee.detail.ddPropertyAgentId': 'รหัสพนักงาน DDProperty',
    'setting.employee.detail.dateRegistered': 'วันที่ลงทะเบียน',
    'setting.employee.detail.watermark': 'ลายน้ำ',
    'setting.employee.detail.applyWatermarkWhenSendingToWeb': 'ใช้ลายน้ำเมื่อส่งไปที่เว็บ',
    'setting.employee.detail.applyWatermarkWhenSendinOnEmain': 'ใช้ลายน้ำเมื่อส่งอีเมล์',
    'setting.employee.detail.applyWatermarkWhenDownloadingPhotos': 'ใช้ลายน้ำเมื่อดาวน์โหลดรูปภาพ',
    'setting.employee.detail.watermarkPosition': 'ตำแหน่งลายน้ำ',
    'setting.employee.detail.massPropertyUpdateFunctions': 'Mass property update functions',
    'setting.employee.detail.updatePropertiesFromFMR': 'Update properties from FMR',
    'setting.employee.detail.updatePropertiesOnWeb': 'Update properties on web',
    'setting.employee.detail.updatePropertiesFromFMRRemark': 'Clicking on this button will update all your properties with information from FMR. Properties, which are parts of large complexes and share property ID with other parts, will not be updated, but shown to you, so that you can manually choose which parts are they. Updating property with FMR information will update properties on the web',
    'setting.employee.detail.updatePropertiesOnWebRemark': 'If you feel that some of properties are not up to date on the web, you can update all of them by clicking on this button',
    'setting.employee.detail.paymentSetting': 'ตั้งค่าการจ่าย',
    'setting.employee.detail.percentCutOfSalesFee': '% cut of sales fee',
    'setting.employee.detail.Salary': 'เงินเดือน',
    'setting.employee.detail.Bonus': 'โบนัส',
    'setting.employee.detail.yearPaymentsToTheOffice': 'Yearly payments to the office',
    'setting.employee.detail.MonthlyInconeForTheOfficeFrom': 'Monthly income for the office from',
    'setting.employee.detail.perYear': 'ต่อปี',
    'setting.employee.detail.perMonth': 'ต่อเดือน',
    'setting.employee.detail.otherPaymentsToOffice1': 'Other payments to office 1',
    'setting.employee.detail.otherPaymentsToOffice2': 'Other payments to office 2',
    'setting.employee.detail.contractPayment': 'Contract payment',
    'setting.employee.detail.authentication': 'Authentication',
    'setting.employee.detail.username': 'Username',
    'setting.employee.detail.oldPassword': 'Old password',
    'setting.employee.detail.newPassword': 'New Password',
    'setting.employee.detail.password': 'Password',
    'setting.employee.detail.confirmPassword': 'Confirm password',
    'setting.employee.detail.confirmNewPassword': 'Confirm new password',
    'setting.employee.detail.admakerUsername': 'Admarker Username',
    'setting.employee.detail.admakerPassword': 'Admarker Password',
    'setting.employee.detail.rights': 'Rights',
    'setting.employee.detail.expireDate': 'Expire Date',
    'setting.employee.detail.inactiveThisUser': 'Inactive this user',
    'setting.employee.detail.inactiveThisUserRemark': "This user will can't access this system, but all property still assigned to the user",
    'setting.employee.detail.activeThisUser': 'Active this user',
    'setting.employee.detail.autogenerateUsename': 'Auto generate username',
    'setting.employee.detail.inactiveModal.header': 'Properties of a user who is being de-activated',
    'setting.employee.detail.inactiveModal.title1': 'User who is being de-activated has ',
    'setting.employee.detail.inactiveModal.title2': ' active properties ( ',
    'setting.employee.detail.inactiveModal.title3': ' of them are on the web) and ',
    'setting.employee.detail.inactiveModal.title4': ' properties in storage. What would you like to do?',
    'setting.employee.detail.inactiveModal.movetoUser': 'Move all properties to another user',
    'setting.employee.detail.inactiveModal.keepPropertiesOnWeb': 'Keep properties on the web as they are now',
    'setting.employee.detail.inactiveModal.pullPropertiesInStorage': 'Put all properties in storage (properties which are on the web will be removed from the web and all properties can be found in Storage tab in property list under de-activated user)',
    'setting.employee.detail.inactiveModal.doNothing': 'Do nothing',
    'setting.employee.detail.inactiveModal.warning': 'Warning: action selected above and confirmed by clicking OK can not be rolled back later.',
    'setting.employee.detail.isAuthorized': 'Is authorized',
    'setting.employee.detail.allowCreateUsers': 'Allow create users',
    'setting.employee.detail.restrictExport': 'Restrict export',
    'setting.employee.detail.isAllowViewContact': 'Is allow view contact',
    'setting.employee.detail.ssl': 'SSL',
    'setting.employee.detail.sentToMeAsBcc': 'Send to me as Bcc',
    'setting.employee.detail.smtpServerName': 'SMTP Server name',
    'setting.employee.detail.smtpUsername': 'SMTP Username',
    'setting.employee.detail.smtpPassword': 'SMTP Password',
    'setting.employee.detail.smtpPort': 'SMTP Port',
    'setting.employee.detail.pop3ServerName': 'POP3 Server name',
    'setting.employee.detail.pop3Username': 'POP3 Username',
    'setting.employee.detail.pop3Password': 'POP3 Password',
    'setting.employee.detail.pop3Port': 'POP3 Port',
    'setting.employee.detail.signature': 'Signature',

    'setting.propertylist.availableList': 'รายการที่สามารถเลือกได้',
    'setting.propertylist.selectedList': 'รายการที่เลือก',
    'setting.propertylist.moveUp': 'ย้ายขึ้น',
    'setting.propertylist.moveDown': 'ย้ายลง',
    'setting.propertylist.update': 'บันทึก',
    
    'alert.notfoundData': 'ไม่พบข้อมูล',
    'type': 'ประเภท',
    'customer': 'ลูกค้า',
    'description': 'รายละเอียด',
    'enquiry': 'ความต้องการลูกค้า',
    'enquiry.source': 'ที่มา',
    'enquiry.memo': 'บันทึก',
    'enquiry.addnote': 'เพิ่มบันทึก',
    'enquiry.name': 'ชื่อ',
    'enquiry.status': 'สถานะ',
    'enquiry.dateAdded': 'วันที่บันทึก',
    'enquiry.saleRepresentative': 'ตัวแทนการขาย',
    'enquiry.findMatchTooltip': 'ค้นหาทรัพย์ที่ตรงกับเงื่อนไข',
    'save': 'บันทึก',
    'dashboard.addmore': 'เพิ่มหน้าต่าง',
    'note': 'คำอธิบาย',
    'amount': 'จำนวนเงิน',
    'editor.writeSomething': 'รายละเอียดต่างๆ',
    'restore': 'เรียกคืนค่า',
    'addmore': 'เพิ่ม',
    'delete': 'ลบ',
    'edit': 'แก้ไข',
    'cancel': 'ยกเลิก',
    'ok': 'ตกลง',
    'update': 'บันทึก',
    'sureDelete': 'ต้องการลบ',
    'sureCancel': 'ต้องการยกเลิก',
    'sureDone': 'ยืนยันการดำเนินการ',
    'done': 'เสร็จสิ้น',
    'search': 'ค้นหา',
    'default': 'ค่าเริ่มต้น',
    'setDefault': 'ตั้งค่า',
    'clear': 'ล้าง',
    'firstProject' : 'firstProject',
    'view': 'View',
    'upload': 'Upload',
    'deleteSelectedRecord': 'ลบรายการที่ถูกเลือก',

    // ERRORS FROM UI-VALIDATION
    'error.offerDetail.name': 'โปรดกรอกชื่อข้อเสนอ',
    'error.offerDetail.name.exceedLength': 'ชื่อข้อเสนอต้องห้ามเกิน 255 ตัวอักษร',
    'error.offerDetail.price': 'โปรดกรอกราคาเสนอ',
    'error.offerDetail.offerStart': 'โปรดเลือกวันที่เริ่มต้นข้อเสนอ',
    'error.offerDetail.offerEnd': 'โปรดเลือกวันที่สิ้นสุดข้อเสนอ',
    'error.contractDetail.name': 'โปรดระบุชื่อสัญญา',
    'error.projectDetail.projectName': 'โปรดกรอกชื่อโครงการ',
    'error.projectDetail.projectRegId': 'โปรดกรอกชื่อโครงการ',
    'error.projectDetail.projectTypes': 'โปรดเลือกประเภทโครงการ',
    'error.projectDetail.developer': 'โปรดกรอกชื่อผู้พัฒนาโครงการ',
    'error.projectDetail.totalUnits': 'โปรดกรอกจำนวนยูนิตทั้งหมด',
    'error.projectDetail.province': 'โปรดเลือกจังหวัด',
    'error.projectDetail.district': 'โปรดเลือกเขต/อำเภอ',
    'error.projectDetail.area': 'โปรดเลือกแขวง/ตำบล',
    'error.projectDetail.address': 'โปรดกรอกที่อยู่',
    'error.projectDetail.yearBuilt': 'โปรดกรอกปีที่สร้าง',
    'error.projectDetail.yearComplete': 'ปีที่สร้างเสร็จต้องมากกว่าปีที่สร้าง',
    'error.projectDetail.status': 'โปรดเลือกสถานะ',
    'error.projectDetail.landSize': 'โปรดกรอกขนาดพื้นที่',
    'error.projectDetail.landSize2': 'ขนาดพื้นที่ต้องมากกว่า 0',
    'error.projectDetail.rai': 'โปรดกรอกไร่',
    'error.projectDetail.ngan': 'โปรดกรอกงาน',
    'error.projectDetail.wa': 'โปรดกรอกวา',
    'error.projectDetail.projectIsDelete': 'โปรเจคนี้ถูกลบแล้ว',
    'error.projectDetail.permissionDenied': 'ไม่มีสิทธิ์เข้าใช้งาน',
    'error.projectUnit.unitName': 'โปรดกรอกชื่อยูนิต',
    'error.projectUnit.unitType': 'โปรดเลือกประเภทยูนิต',
    'error.projectUnit.size': 'โปรดกรอกขนาดพื้นที่/พื้นที่ต้องมีค่ามากกว่า 0',
    'error.projectDetail.videoLink': 'กรุณากรอก URL ที่มาจาก YouTube',
    'error.projectEnquiry.contact': 'กรุณาเลือกผู้ติดต่อ',
    'error.projectEnquiry.propertyType': 'กรุณาเลือกประเภทอสังหาริมทรัพย์',
    'error.projectEnquiry.size': 'กรุณากรอกขนาดพื้นที่ใช้สอยให้ถูกต้อง',
    'error.projectEnquiry.landSize': 'กรุณากรอกขนาดที่ดินให้ถูกต้อง',
    'error.projectEnquiry.price': 'กรุณากรอกราคาให้ถูกต้อง',
    'error.projectEnquiry.priceStart': 'กรุณากรอกราคาเริ่มต้น',
    'error.projectEnquiry.priceTo': 'กรุณากรอกราคามากที่สุด',
    'error.addNewUnit.unitNumber': 'กรุณากรอกจำนวนยูนิต',
    'error.addNewUnit.invalidUnitNumber': 'จำนวนยูนิตไม่ถูกต้อง',
    'error.addNewUnit.price': 'กรุณากรอกราคา',
    'error.addNewUnit.price2': 'กรุณากรอกราคามากกว่าหรือเท่ากับราคาต่ำสุด',
    'error.addNewUnit.minimumPrice': 'กรุณากรอกราคาต่ำสุด',
    'error.salesCommissionSetting.data.atleastone': 'กรุณากรอกค่าคอมมิชชั่นอย่างน้อย 1 บรรทัด',
    'error.salesCommissionSetting.data.moreThanZero': 'กรุณากรอกค่ายอดคอมมิชชั่นสะสมมากกว่า 0',
    'error.salesCommissionSetting.data.fromMoreThanTo': 'กรุณากรอกค่ายอดคอมมิชชั่นสะสมเริ่มต้นมากกว่าถึงยอดคอมมิชชั่น',
    'error.salesCommissionSetting.data.nonOverLap': 'กรุณากรอกค่ายอดคอมมิชชั่นสะสมที่ไม่คาบเกี่ยว',
    'error.salesCommissionSetting.data.continuous': 'กรุณากรอกค่ายอดคอมมิชชั่นให้ต่อเนื่องกัน',
    'error.salesCommissionSetting.data.cannotBeEmpty': 'กรุณากรอกค่ายอดคอมมิชชั่นสะสมเริ่มต้น, ถึงยอดคอมมิชชั่น หรือ ส่วนแบ่งค่าคอมมิชชั่น',
    'error.deedDetail.name': 'Please input deed name.',
    'error.deedDetail.id': 'Please input deed detail.',
    'error.priceToMustGreaterThanPriceFrom': 'กรุณากรอกราคาให้ถูกต้อง',
    'error.minPriceToMustGreaterThanPriceFrom': 'กรุณากรอกราคาขั้นค่ำให้ถูกต้อง',
    'error.pleaseInputPriceFrom': 'กรุณากรอกราคาเริ่มต้น',
    'error.pleaseInputPriceTo': 'กรุณากรอกราคามากที่สุด',
    'error.pleaseInputMinPriceFrom': 'กรุณากรอกราคาขั้นค่ำเริ่มต้น',
    'error.pleaseInputMinPriceTo': 'กรุณากรอกราคาขั้นค่ำมากที่สุด',
    'error.pleaseInputName': 'กรุณากรอกชื่อ',
    'error.pleaseInputEmail': 'กรุณากรอกอีเมล์',
    'error.pleaseInputUsername': 'กรุณากรอกชื่อผู้ใช้งาน',
    'error.pleaseInputPassword': 'กรุณากรอกพาสเวิร์ด',
    'error.pleaseInputOldPassword': 'กรุณากรอกพาสเวิร์ดเดิม',
    'error.pleaseInputConfirmPassword': 'กรุณากรอกยืนยันพาสเวิร์ด',
    'error.pleaseInputValidEmail': 'กรุณากรอกอีเมล์ให้ถูกรูปแบบ',
    'error.uploadLimitExceed': 'อัพโหลดรูปภาพเกินที่กำหนด',
    
    // NOTIFICATIONS
    'notification.savecomplete': 'บันทึกข้อมูลเรียบร้อย',

    // Languages
    'language.th.sidebar': 'ภาษาไทย',
    'language.en.sidebar': 'English',
    'language.is.sidebar': 'íslenska',

    /* ERRORS from saga */
    'INVALID_LOGIN': 'Invalid Login',

    /*projectDetailNewUnitModal*/
    'projectDetailNewUnit.input.unitNumer': 'จำนวนยูนิต',
    'projectDetailNewUnit.input.unitNumer.tooltip': 'หมายเลขยูนิตสามารถกรอกเป็นช่วงโดยคั่นด้วยเครื่องหมายจุลภาค (,) เช่น 1, 3, 5-12',
    'projectDetailNewUnit.input.rentOrSale': 'ขาย/เช่า',
    'projectDetailNewUnit.input.sale': 'ขาย',
    'projectDetailNewUnit.input.rent': 'เช่า',
    'projectDetailNewUnit.input.unitType': 'ประเภทยูนิต',
    'projectDetailNewUnit.input.price': 'ราคา',
    'projectDetailNewUnit.input.minimumPrice': 'ราคาต่ำสุด',
    'projectDetailNewUnit.input.selectUnitType': 'เลือกประเภทยูนิต',
    'projectDetailNewUnit.header.newUnit': 'สร้างยูนิต',
    'projectDetailNewUnit.button.generate': 'สร้าง',


    /*projectDetailNewEnquiryModal*/
    'projectDetailNewEnquiry.select.pleaseSelect': 'กรุณาเลือก',
    'projectDetailNewEnquiry.select.contact': 'ชื่อผู้ติดต่อ',
    'projectDetailNewEnquiry.select.rentOrSale': 'เช่า/ซื้อ',
    'projectDetailNewEnquiry.select.rent': 'เช่า',
    'projectDetailNewEnquiry.select.sale': 'ซื้อ',
    'projectDetailNewEnquiry.input.type': 'เชิงพาณิชย์/ที่อยู่อาศัย',
    'projectDetailNewEnquiry.select.propertyType': 'ประเภทอสังหาฯ',
    'projectDetailNewEnquiry.input.sizeStart': 'ขนาดพื้นที่ใช้สอบ (ตรม.)',
    'projectDetailNewEnquiry.input.sizeEnd': 'ถึง',
    'projectDetailNewEnquiry.input.landStart': 'ขนาดที่ดิน (ตรว.)',
    'projectDetailNewEnquiry.input.landEnd': 'ถึง',
    'projectDetailNewEnquiry.input.priceStart': 'ราคา',
    'projectDetailNewEnquiry.input.priceEnd': 'ถึง',
    'projectDetailNewEnquiry.input.noOfBedrooms': 'จำนวนห้องนอน',
    'projectDetailNewEnquiry.select.province': 'จังหวัด',
    'projectDetailNewEnquiry.select.city': 'เมือง',
    'projectDetailNewEnquiry.select.zone': 'ย่าน',
    'projectDetailNewEnquiry.input.description': 'รายละเอียด',
    'projectDetailNewEnquiry.select.source': 'ติดต่อจาก',
    'projectDetailNewEnquiry.select.status': 'สถานะ',
    'projectDetailNewEnquiry.header.newEnquiry': 'เพิ่มลูกค้าที่สนใจ',
    'projectDetailNewEnquiry.button.save': 'บันทึก',
    'projectDetailNewEnquiry.button.cancel': 'ยกเลิก',

    'report.propertyReport.propertyReport': 'รายงานทรัพย์สิน',
    'report.propertyReport.isExclusive': 'สัญญาแบบ ปิด/เปิด',
    'report.propertyReport.dateFrom': 'ตั้งแต่วันที่',
    'report.propertyReport.dateTo': 'ถึงวันที่',
    'report.propertyReport.advanceFilter': 'ค้นหาขั้นสูง',
    'report.propertyReport.propertyId': 'รหัสสินทรัพย์',
    'report.propertyReport.address2': 'ที่อยู่2',
    'report.propertyReport.priceFrom': 'ตั้งแต่ราคา',
    'report.propertyReport.priceTo': 'ถึงราคา',
    'report.propertyReport.exclusive': 'สัญญาแบบปิด',
    'report.propertyReport.nonExclusive': 'สัญญาแบบเปิด',

    'description.forReport': 'รายละเอียดอสังหาริมทรัพย์(รายงาน)',
    'description.standardText': 'ใช้ข้อความมาตรฐาน',
    'description.saveStandardText': 'บันทึกข้อความมาตรฐาน',
    'description.renovation': 'ปรับปรุง',
    'description.knownDefects': 'ปัญหาที่พบ',
    'description.openHouse': 'รายละเอียดการเยี่ยมชม',
    'description.advertisement': 'รายละเอียดโฆษณา',
    'description.portal': 'รายละเอียดบนเว็บไซต์',

    'alertModal.duplicateBuyer': 'ชื่อผู้ซื้อซ้ำไม่สามารถเพิ่มได้',
    'alertModal.duplicateOwner': 'ชื่อผู้ขายซ้ำไม่สามารถเพิ่มได้',

    'oldLoan':'Old Loan',
    'ilsloan': 'ILS Loan',
    'newLoan': 'New Loan',
    'bond': 'Bonds',
    'loan.propertyLoan': 'Property Loan',
    'loan.takenLoan': 'Taken Loan',
    'loan.mortgageRight': 'Mortgage Right',
    'loan.takeOver': 'Take Over',
    'loan.mortgagee': 'Mortgagee',
    'loan.interest': 'Interests',
    'loan.originalAmount': 'Original Amount',
    'loan.loanRemainder': 'Loan Remainder',
    'loan.payment':'Payment',
    'loan.remainingPayment':'Remaining Payment',
    'loan.nextPaymentDue':'Next Payment Due',
    'loan.takenOverSum': 'Taken over loan summary',
    'loan.canceledSum': 'Cancel summary',
    'loan.agreedSum': 'Agreed summary',
    'loan.paymentPerPeriodSum': 'Payment per period summary',
    'loan.loanAmountSum': 'Loan amount summary',
    'loan.loanTakenOn':'Loan Taken on',
    'loan.costToPay':'Cost to Pay',
    'loan.baseIndex':'Base Index',
    'loan.firstPayment':'First Payment',
    'loan.lockedRemainder':'Locked Remainder',
    'loan.AdditionalAmount': 'Additional Amount',
    'loan.InterestedCalculatedFrom': 'Interested Calculated From',
    'loan.InterestedCalculatedFromText': 'Interests Calc. from - Text',
    'loan.paymentPerYear': 'Payment per year',
    'loan.numberOfYear': 'Number of year',
    'loan.numberOfPayment': 'Number of payments',
    'loan.standardText': 'Standard Text',
    'loan.title': 'Loan Title',
    'loan.payOutDate': 'Loan pay out date',
    'bond.title': 'Bond Title',
    'loan.contractDate': 'Contract Date',
    'loan.deedDate': 'Deed Date',
    'loan.transferDate': 'Transfer Date',
    'loan.previousDeedDue': 'Previous Deed Due',
    'loan.newLoan.NumberOfPaymentsHelp':'จำนวนจะถูกคำนวณจากงวดต่อปีคูณด้วยจำนวนปี',

    'contact.allContacts': 'ผู้ติดต่อทั้งหมด',
    'contact.myContacts': 'ผู้ติดต่อของฉัน',
    'contact.allEnquiries': 'ความต้องการของลูกค้าทั้งหมด',
    'contact.myEnquiries': 'ความต้องการของลูกค้าของฉัน',
    'contact.allLeads': 'ผู้สนใจทั้งหมด',
    'contact.myLeads': 'ผู้สนใจของฉัน',
    'contact.dateAdded': 'วันที่บันทึก',
    'contact.exportSelected': 'ออกรายงานรายการที่เลือก',
    'contact.exportAll': 'ออกรายงานทั้งหมด',
    'contact.contactDetail.ssn': 'เลขประจำตัวประชาชน',
    'contact.contactDetail.homeAddress': 'ที่อยู่',
    'contact.contactDetail.homePhone': 'เบอร์โทรศัพท์บ้าน',
    'contact.contactDetail.workPhone': 'เบอร์โทรศัพท์ที่ทำงาน',
    'contact.contactDetail.mobilePhone': 'เบอร์โทรศัพท์มือถือ',
    'contact.contactDetail.email': 'อีเมล์',
    'contact.contactDetail.lineId': 'ไลน์ไอดี',
    'contact.contactDetail.company': 'บริษัท',
    'contact.contactDetail.position': 'ตำแหน่ง',
    'contact.contactDetail.website': 'เว็บไซต์',
    'contact.contactDetail.spouse': 'คู่สมรส',
    'contact.contactDetail.birthDate': 'วันเกิด',
    'contact.contactDetail.assignToSale': 'เจ้าของผู้ติดต่อ',
    'contact.contactDetail.source': 'แหล่งที่มา',
    'contact.contactDetail.status': 'สถานะ',
    'contact.contactDetail.remind': 'แจ้งเตือน',
    'contact.contactDetail.memo': 'บันทึก',
    'contact.contactDetail.signature': 'การลงนาม',
    'contact.contactDetail.button.email': 'อีเมล์',
    'contact.contactDetail.button.nameCard': 'นามบัตร',
    'contact.contactDetail.button.calendar': 'ปฏิทิน',
    'contact.contactDetail.button.relatedProperty': 'สินทรัพย์ที่เกี่ยวข้อง',
    'contact.contactDetail.button.relatedDocument': 'เอกสาร',
    'contact.contactDetail.button.leads': 'ผู้สนใจ',
    'contact.contactDetail.button.enquiries': 'ความต้องการลูกค้า',
    'contact.contactDetail.propertyStatus': 'สถานะอสังหาฯ ',
    'contact.contactDetail.relatedStatus': 'สถานะถือครอง',
    'contact.contactDetail.relatedProperty': 'สินทรัพย์ที่เกี่ยวข้อง',

    'enquiry.enquiryDetail.create': 'สร้างความต้องการลูกค้าใหม่',
    'enquiry.enquiryDetail.update': 'ความต้องการลูกค้า',
    'enquiry.enquiryDetail.mustSelectlease1Field':'Must have value lease 1 field.',
    'enquiry.matchProperty.utilizeSpace':'พื้นที่ใช้สอย',
    'enquiry.matchProperty.action':'Action',
    'enquiry.matchProperty.created':'สร้างแล้ว',
    'enquiry.matchProperty.createLead':'สร้างความสนใจ',
    'enquiry.matchProperty.findMatched':'ค้นหาทรัพย์ที่ตรงกัน',
    'enquiry.matchProperty.matchedProperties':'สินทรัพย์ที่ตรงกัน',
    
    'lead.table.header.propertyname': 'ชื่ออสังหาฯ',
    'lead.leadDetail.header': 'รายละเอียดผู้สนใจ',
    'lead.leadDetail.customerName': 'ชื่อลูกค้า',
    'lead.leadDetail.interestedProperty': 'สินทรัพย์ที่สนใจ',
    'lead.leadDetail.callDate': 'วันที่ติดต่อ',
    'lead.leadDetail.openHouse': 'เยี่ยมชม',
    'lead.leadDetail.source': 'แหล่งที่มา',
    'lead.leadDetail.status': 'สถานะ',
    'lead.leadDetail.noPropertyName': 'ไม่มีชื่อสินทรัพย์',

    'batch.source' : 'แหล่งที่มา',
    'batch.status' : 'สถานะ',
    'batch.selectStatus': 'เลือกสถานะ',
    'batch.selectSource': 'เลือกแหล่งที่มา',
    'batch.selectOnWeb': 'เลือกให้แสดงบนเว็บไซต์',

    'email.to': 'ถึง',
    'email.cc': 'สำเนา',
    'email.subject': 'หัวข้อ',
    'email.sendEmail': 'ส่งอีเมล์',
    'email.attachmentPolicy': 'รูปภาพต้องมีขนาดเล็กกว่า 1 MB/ไฟล์อื่นๆ ต้องมีขนาดเล็กกว่า 10 MB',
    'email.sendComplete': 'ส่งอีเมล์เรียบร้อย',

    'contact.sendDetail': 'ส่งนามบัตร',

    'offerEvent': 'ข้อเสนอ',
    'contractEvent': 'สัญญา',
    'deedEvent': 'โฉนด',
    'leadEvent': 'ผู้สนใจ',
    'propertyactivityEvent': 'บันทึกกิจกรรมของสินทรัพย์',
    'birthdayEvent': 'วันเกิด',
    'propertyopenhouseEvent': 'วันเปิดเยี่ยมชมสินทรัพย์',
    'propertyexpireEvent': 'วันหมดสัญญา',
    'calendar.myCalendar': 'บันทึกกิจกรรมของฉัน',
    'calendar.allCalendar': 'บันทึกกิจกรรมทั้งหมด',

    'financialStatement.portalAddress': 'แขวง/ตำบล',
    'financialStatement.paymentSummary': 'สรุปยอดการชำระเงิน',
    'financialStatement.offerPrice': 'ข้อเสนอราคา',
    'financialStatement.mortgage': 'จำนอง',
    'financialStatement.ilsLoan': 'สินเชื่อ ILS',
    'financialStatement.ilsLoanExtra': 'ILS Loan Extra',
    'financialStatement.newLoan': 'สินเชื่อใหม่',
    'financialStatement.bonds': 'พันธบัตร',
    'financialStatement.paymentSum': 'จำนวนเงินรวม',
    'financialStatement.diff': 'ส่วนต่าง',

    'propertyList.myProperty':'สินทรัพย์ของฉัน',
    'propertyList.allProperty':'สินทรัพย์ทั้งหมด',
    'propertyList.owner':'เจ้าของ',
    'propertyList.modifiedOn': 'วันที่แก้ไขข้อมูล',
    'propertyList.propertyAddress':'ที่อยู่สินทรัพย์',
    'propertyList.addProperty':'เพิ่มสินทรัพย์',
    'propertyList.newForSale':'รายการขาย',
    'propertyList.newForRent':'รายการเช่า',
    'propertyList.recentActivity':'นัดหมายล่าสุด',

    'propertyDetail': 'ข้อมูลสินทรัพย์',
    'propertyDetail.description': 'รายละเอียด',
    'propertyDetail.findLocationFromAddress': 'ค้นหาสถานที่จากที่อยู่',
    'propertyDetail.updateFromFMR': 'ดึงข้อมูลจาก FMR',
    'propertyDetail.viewOnFMR': 'View on FMR',
    'propertyDetail.landNumber': 'เลขที่ที่ดิน',
    'propertyDetail.landSize': 'ขนาดที่ดิน',
    'propertyDetail.propertyPart': 'สัดส่วนการเป็นเจ้าของ',
    'propertyDetail.houseAppraisal': 'ราคาประเมินสินทรัพย์',
    'propertyDetail.landSizeSqm': 'ขนาดที่ดิน (ตร.ม)',
    'propertyDetail.buildingFloor': 'จำนวนชั้นของอาคาร',
    'propertyDetail.unitFloor': 'ชั้นของยูนิต',
    'propertyDetail.bedroom': 'ห้องนอน',
    'propertyDetail.bathroom': 'ห้องน้ำ',
    'propertyDetail.livingroom': 'ห้องนั่งเล่น',
    'propertyDetail.totalroom': 'จำนวนห้องทั้งหมด',
    'propertyDetail.aircondition': 'เครื่องปรับอากาศ',
    'propertyDetail.parkingLot': 'ที่จอดรถ',
    'propertyDetail.storage': 'ห้องเก็บของ',
    'propertyDetail.balcony': 'ระเบียง',
    'propertyDetail.laundry': 'ห้องซักรีด',
    'propertyDetail.garden': 'สวน',
    'propertyDetail.otherroom': 'ห้องอื่นๆ',
    'propertyDetail.buildingStage': 'Building Stage',
    'propertyDetail.delivery': 'Delivery',
    'propertyDetail.entrance': 'Entrance',
    'propertyDetail.heating': 'Heating',
    'propertyDetail.windows': 'Windows',
    'propertyDetail.groundFloorMaterial': 'วัสดุพื้นชั้นล่าง',
    'propertyDetail.upperFloorMaterial': 'วัสดุพื้นชั้นบน',
    'propertyDetail.elevator': 'ลิฟต์',
    'propertyDetail.preemption': 'ใบจอง',
    'propertyDetail.exchangeAgreementNo': 'เลขที่สัญญาซื้อขาย',
    'propertyDetail.mapSheetNo': 'ระวาง',
    'propertyDetail.parcelNo': 'เลขที่ดิน',
    'propertyDetail.dealingFileNo': 'เลขที่หน้าสำรวจ',
    'propertyDetail.groundLeaseAgreementNo': 'เลขที่สัญญาเช่าที่ดิน',
    'propertyDetail.encumbranceFileNo': 'สถานะโฉนด',
    'propertyDetail.encumbranceStatement': 'เอกสารติดพันตัวทรัพย์',
    'propertyDetail.encumbranceNote': 'บันทึกเอกสารติดพันตัวทรัพย์',
    'propertyDetail.taxAndCost': 'ภาษีและค่าใช้จ่ายอื่น',
    'propertyDetail.orderTax': 'สอบถามข้อมูลภาษี',
    'propertyDetail.waterTax': 'ค่าน้ำ',
    'propertyDetail.fireInsurance': 'ประกันอัคคีภัย',
    'propertyDetail.orderInsurance': 'สอบถามข้อมูลประกัน',
    'propertyDetail.monthlyCost': 'ค่าใช้จ่ายรายเดือน',
    'propertyDetail.rentalDetail': 'รายละเอียดการเช่า',
    'propertyDetail.rentPeriod': 'ระยะเวลาเช่า',
    'propertyDetail.paymentFrequency': 'รอบชำระค่าเช่า',
    'propertyDetail.rentInsurance1': 'บริษัทประกัน 1',
    'propertyDetail.rentInsurance2': 'บริษัทประกัน 2',
    'propertyDetail.deliveryFrom': 'เช่าตั้งแต่',
    'propertyDetail.deliveryTo': 'เช่าจนถึง',
    'propertyDetail.electricity': 'ไฟฟ้า',
    'propertyDetail.water': 'น้ำประปา',
    'propertyDetail.other': 'อื่นๆ',
    'propertyDetail.index': 'ดัชนี',
    'propertyDetail.propertyManagement': 'นิติบุคคลอาคาร',
    'propertyDetail.management': 'จัดการดำเนินงาน',
    'propertyDetail.janitorSalary': 'เงินเดือนแม่บ้าน',
    'propertyDetail.cleaningOfJointArea': 'ทำความสะอาดที่ส่วนกลาง',
    'propertyDetail.electricityInJointArea': 'ไฟฟ้าพื้นที่ส่วนกลาง',
    'propertyDetail.cleaningOfWasteDisposalArea': 'ทำความสะอาดที่ทิ้งขยะ',
    'propertyDetail.homeOwnerInsurance': 'ประกันชีวิตเจ้าบ้าน',
    'propertyDetail.paymentDueDate': 'วันจ่ายค่าส่วนกลาง',
    'propertyDetail.commercialBuildingSpecification': 'ลักษณะจำเพาะอาคารพาณิชย์',
    'propertyDetail.premisesSize': 'ขนาดที่ดิน (หน้ากว้าง x ลึก) (เมตร)',
    'propertyDetail.buildingSize': 'ขนาดอาคาร (หน้ากว้าง x ลึก) (เมตร)',
    'propertyDetail.floorArea': 'พื้นที่ชั้น (ตร.ม)',
    'propertyDetail.loftArea': 'พื้นที่ห้องใต้หลังคา (ตร.ม)',
    'propertyDetail.bearingCapacity': 'รับน้ำหนัก (ตัน/ตร.ม)',
    'propertyDetail.ridgeHeight': 'ความสูงรั้ว (เมตร)',
    'propertyDetail.highestWall': 'กำแพงสูงสุด (เมตร)',
    'propertyDetail.lowestWall': 'กำแพงเตี้ยสุด (เมตร)',
    'propertyDetail.sizeInCubicMeter': 'ขนาดพื้นที่ (ลบ.ม)',
    'propertyDetail.noOfDirveThroughDoor': 'จำนวนประตูสำหรับรถผ่าน',
    'propertyDetail.heightOfDriveThroughDoor': 'ความสูงประตูสำหรับรถผ่าน',
    'propertyDetail.roof': 'หลังคา',
    'propertyDetail.noOfGroundParkingSpace': 'พื้นที่จอดรถกลางแจ้ง',
    'propertyDetail.buildingRight': 'พื้นที่อนุญาตก่อสร้าง',
    'propertyDetail.groundFloor': 'ชั้นลอย',
    'propertyDetail.rentPrice': 'ราคาเช่า',
    'propertyDetail.rentIncome': 'รายได้จากค่าเช่า',
    'propertyDetail.rentStarted': 'วันเริ่มเช่า',
    'propertyDetail.rentEnd': 'วันสิ้นสุดการเช่า',
    'propertyDetail.termOfannulment': 'เงื่อนไขการเพิกถอน',
    'propertyDetail.loadingDoor': 'ประตูขนส่งสินค้า',
    'propertyDetail.saleCommission': 'คอมมิชชั่น (%)',
    'propertyDetail.saleCommission.exceedPercent': 'เปอร์เซนต์ต้องห้ามเกิน 100%',
    'propertyDetail.saleCommissionFixed': 'คอมมิชชั่น (บาท)',
    'propertyDetail.brokerageContract': 'สัญญานายหน้า',
    'propertyDetail.openContract': 'สัญญาแบบเปิด',
    'propertyDetail.exclusiveContract': 'สัญญาแบบปิด',
    'propertyDetail.featured': 'สินทรัพย์แนะนำ',
    'propertyDetail.advertised': 'โฆษณาสินทรัพย์',
    'propertyDetail.listingDate': 'วันลงสินทรัพย์',
    'propertyDetail.listingExpireDate': 'วันหมดสัญญาขาย',
    'propertyDetail.propertyStatus': 'สถานะสินทรัพย์',
    'propertyDetail.error.selectAgent': 'โปรดเลือกตัวแทนการขาย',
    'propertyDetail.archived': 'อยู่ในคลังข้อมูล',
    'propertyDetail.deleted': 'ลบสินทรัพย์',
    'propertyDetail.createLead': 'บันทึกผู้สนใจ',
    'propertyDetail.showLead': 'แสดงผู้สนใจ',
    'propertyDetail.convertToRent': 'เปลี่ยนเป็นเช่า',
    'propertyDetail.convertToSale': 'เปลี่ยนเป็นขาย',
    'propertyDetail.convertToCommercial': 'เปลี่ยนเป็นประเภทพาณิชย์',
    'propertyDetail.convertToResidential': 'เปลี่ยนเป็นประเภทที่อยู่อาศัย',
    'propertyDetail.duplicate': 'สำเนาสินทรัพย์',
    'propertyDetail.archive': 'เก็บเข้าคลังข้อมูล',
    'propertyDetail.unArchive': 'นำออกจากคลังข้อมูล',
    'propertyDetail.publishing': 'การประกาศ',
    'propertyDetail.inProgress': 'กำลังดำเนินการ',
    'propertyDetail.sureToArchive': 'ยืนยันที่จะเก็บเข้าคลังข้อมูล?',
    'propertyDetail.video': 'วีดีโอ',
    'propertyDetail.blueprints': 'แบบบ้าน',
    'propertyDetail.files': 'ไฟล์',
    'propertyDetail.sizeSqureMeter': 'ขนาด (ตร.ม.)',
    'propertyDetail.error.valueExceedLength': 'ราคาเกินช่วงที่กำหนด',
    'propertyDetail.error.limitLength': 'ตัวอักษรสามารถสูงสุดได้',
    'propertyDetail.error.character': 'ตัวอักษร',
    'propertyDetail.error.invalidEmail': 'อีเมล์ไม่ถูกต้อง',
    'propertyDetail.pictureAndFiles': 'รูปภาพ/ไฟล์แนบ',
    'propertyPicture.applyWatermarkSendingToWeb': 'ประทับลายน้ำเมื่อส่งขึ้นเว็ป',
    'propertyPicture.watermarkPosition': 'ตำแหน่งลายน้ำ',
    'propertyPicture.watermarkSetting': 'ตั้งค่าลายน้ำ',
    'propertyPicture.previewWatermark': 'แสดงภาพพร้อมลายน้ำ',
    'propertyPicture.useUserSetting': 'ใช้ค่ามาตราฐาน (เมื่อบันทึกข้อมูลมาตราฐานจะบันทึกตามค่าที่เปลี่ยน)',
    'propertyPicture.useSpecificSetting': 'ตั้งค่าลายน้ำเฉพาะสินทรัพย์นี้',
    'propertyPicture.topLeft': 'ซ้ายบน',
    'propertyPicture.topRight': 'ขวาบน',
    'propertyPicture.bottomLeft': 'ซ้ายล่าง',
    'propertyPicture.bottomRight': 'ขวาล่าง',
    'propertyPicture.center': 'กลาง',
    'propertyPicture.addVideo': 'เพิ่มวิดีโอ',
    'propertyPicture.url': 'ลิงค์วิดีโอ',
    'propertyPicture.title': 'ชื่อวีดีโอ',
    'propertyPicture.pleaseInputUrl': 'กรุณากรอกลิงค์วิดีโอ',
    'propertyDetail.convertTypeDescription': 'หลังจากที่สินทรัพย์ได้รับการเปลี่ยนแปลงแล้วประเภทของสินทรัพย์เก่าจะหายไปกรุณาเลือกประเภทของสินทรัพย์ใหม่แล้วคลิกโอเคเพื่อดำเนินการ',
    'propertyDetail.owners': 'เจ้าของ',
    'propertyPicture.ownerInformation': 'ข้อมูลเจ้าบ้าน',
    'propertyPicture.renterInformation': 'ข้อมูลผู้เช่า',
    'propertyDetail.Loans': 'เงินกู้/สินเชื่อ',
    'propertyLoan.vr': 'ลำดับ',
    'propertyLoan.takeOver': 'สถานะ',
    'propertyLoan.mortgagee': 'ผู้รับจำนอง',
    'propertyLoan.interest': 'ดอกเบี้ย',
    'propertyLoan.originalAmount': 'เงินต้น',
    'propertyLoan.loanRemainder': 'หนี้สินส่วนเหลือ',
    'propertyLoan.payment': 'ยอดชำระ',
    'propertyLoan.remainingPayment': 'ยอดชำระคงเหลือ',
    'propertyLoan.nextPaymentDue': 'วันที่ชำระครั้งถัดไป',
    'propertyLoan.notSendToWeb': 'ไม่ส่งขึ้นเว็บไซต์',
    'propertyLoan.summaryByMortgagee': 'ยอดตามผู้รับจำนอง',
    'propertyLoan.summaryByLoanStatus': 'ยอดตามสถานะสินเชื่อ',
    'propertyLoan.status': 'สถานะ',
    'propertyLoan.amount': 'ยอดเงิน',
    'propertyLoan.currency': 'สกุลเงิน',
    'propertyLoan.exchangeRate': 'อัตราแลกเปลี่ยน',
    'propertyLoan.originalCurrencyAmount': 'เงินต้นจากสกุลเงินที่เลือก',
    'propertyLoan.interestRate': 'อัตราดอกเบี้ย',
    'propertyLoan.loanNumber': 'หมายเลขเงินกู้',
    'propertyLoan.pledge': 'มัดจำ',
    'propertyLoan.originalPayment': 'เงินดาวน์',
    'propertyLoan.baseIndex': 'ราคาดัชนี',
    'propertyLoan.index': 'ดัชนี',
    'propertyLoan.todayIndex': 'ดัชนีวันนี้',
    'propertyLoan.typeOfLoan': 'ประเภทเงินกู้',
    'propertyLoan.correction': 'ปรับยอด',
    'propertyLoan.lockedRemainder': 'ยอดคงเหลือขั้นต่ำ',
    'propertyLoan.paymentPerYear': 'ยอดชำระ/ปี',
    'propertyLoan.paymentCorrection': 'ปรับยอดชำระ',
    'propertyLoan.lockedPayment': 'ยอดชำระขั้นต่ำ',
    'propertyLoan.startDate': 'วันเริ่มชำระ',
    'propertyLoan.realCost': 'ค่าใช้จ่ายจริง',
    'propertyLoan.remark1': 'ระบบคำนวณเงินกู้อัตโนมัติจะทำงานเมื่อข้อมูลในช่องสีแดงถูกบันทึกครบทุกช่อง',
    'propertyLoan.remark2': 'ระบบคำนวณเงินกู้คำนวณจากยอดเงินต้นที่กรอก เพื่อคำนวณหาเงินกู้คงเหลือและยอดชำระต่อเดือน ยอดดังกล่าวไม่ถูกคำนวณร่วมกับการเปลี่ยนแปลงอื่นๆ ระหว่างการชำระ',
    'propertyLoan.validate.lessThan' : 'ยอดชำระคงเหลือต้องน้อยกว่าเงินดาวน์',
    'propertyDetail.activityLog': 'รายงานกิจกรรม',
    'propertyDetail.history': 'ประวัติการเปลี่ยนแปลง',
    'propertyActivityLog.addActivity': 'เพิ่มนัดหมาย',
    'propertyActivityLog.editActivity': 'แก้ไขนัดหมาย',
    'propertyHistory.sureToRestore': 'ยืนยันการนำข้อมูลเก่ากลับมาใช้'
};



// WEBPACK FOOTER //
// ./src/languageProvider/locales/th_TH.ts